const language = {
    lang:'pl',
    en: {
      id:'Id',
      pages:{
        login:{
          loginTitle:"Log in",
          loginPlaceholder:"login...",
          passPlaceholder:"password...",
          loginButton:"Login"
        },
      },
      meta:"Name ",
      type:"Type",
      answer:"Answer",
      emailVerificationPromptText : 'The email is not correct format ! '  ,
      clients : "Clients",
      client : "Client",
      dashboard : "Dashboard",
      users : "Users",
      pipeline : "Pipeline",
      "pipeline creator" : "Pipeline kreator",
      stagetype: "Pipeline",
      schedule : "Schedule",
      projects : "Projects",
      project : "Project",
      stage:"Stage",
      dLastContact:"Last contact",
      address:"Address",
      age:"Age",
      probability:"Probability",
      language:"Language",
      category:"Category",
      product:"Product",
      fill:"...",
      groupe:"Group",
      groups:"Groups",
      resources:"Resources",
      resources:"Resources",
      teacher:"Teacher",
      price:"Price",
      priceIndividual:"Individual price",
      priceGroup:"Group price",
      source:"Source",
      gMeetId:"Gmeet ID",
      telegramUsername:"Telegram",
      set:"Sets",
      grid:"Game",
      modals:{
        conversationprogress:{
          createTitle:"You can add quiz here",
          updateDescription: "You can edit quiz here",
          updateTitle : "Quiz update",
        },
        events:{
          createTitle:"You can add event here",
          updateDescription: "You can edit event here",
          updateTitle : "Event update",
        },
        answers:{
          createTitle:"You can add message here",
          updateDescription: "You can edit message here",
          updateTitle : "Message update",
        },
        conversations:{
          createTitle:"You can add conversation here",
          updateDescription: "You can edit conversation here",
          updateTitle : "Conversation update",
        },
        
        students:{
          createTitle:"You can add student here",
          updateDescription: "You can edit student here",
          updateTitle : "Student update",
        },
        carDocuments:{
          createTitle:"Tutaj możesz dodać document",
          updateDescription: "Pola nie można edytować",
          updateTitle : "Edycja documentu nie mozliwa",
        },
        projects:{
          createTitle:"You can add project here",
          updateDescription: "Project update",
          updateTitle : "You can edit project here",
        },
       users:{
        createTitle:"You can add user here",
        updateDescription: "You can edit user here",
        updateTitle : "User update",
       },
       clients:{
        createTitle:"You can add client here",
        updateDescription: "You can edit client here",
        updateTitle : "Client update",
       },
       lessons:{
        createTitle:"You can add a lesson here",
        updateDescription: "You can edit the lesson here",
        updateTitle : "Lesson card",
       },
       games:{
        createTitle:"You can add client here",
        updateDescription: "You can edit client here",
        updateTitle : "Client update",
       },
       groups:{
        createTitle:"You can add group here",
        updateDescription: "You can edit group here",
        updateTitle : "Group update",
       },
       quizGeneration:{
        title:"Generate quiz",
        lessonLabel:"Lesson",
        lessonDefault:"No lesson (optional)",
        additionalWordsLabel:"Additional words",
        additionalWordsPlaceholder:"Search for a word...",
        studentWordsLabel:"Pick from the student's own words",
        noStudentWords:"This student has no saved words yet",
        sourceHint:"Pick at least one word, or choose a lesson that already has words attached",
        sourceRequiredError:"Pick at least one word first",
        difficultyLabel:"Difficulty",
        difficultyDefault:"Use default",
        difficultyEasy:"Easy",
        difficultyMedium:"Medium",
        difficultyHard:"Hard",
        questionCountLabel:"Question count",
        questionCountPlaceholder:"Default",
        optionsPerQuestionLabel:"Answer options",
        optionsPerQuestionPlaceholder:"Default",
        textAnswerRatioLabel:"Text-answer question ratio (%)",
        textAnswerRatioPlaceholder:"Default",
        useAiLabel:"Question style",
        useAiDefault:"Use default",
        useAiOn:"AI-generated",
        useAiOff:"Deterministic (no AI)",
        creativityLabel:"AI question variety",
        creativityDefault:"Use default",
        autoNamingLabel:"Use AI to name and describe the quiz",
        titleLabel:"Title",
        titlePlaceholder:"Quiz title",
        descriptionLabel:"Description",
        descriptionPlaceholder:"Quiz description",
        generateBtn:"Generate",
        generating:"Generating...",
        genericError:"Failed to generate the quiz",
        minimizeTooltip:"Run in background",
       }
      },
      tasks : "Tasks",
      games : "Games",
      value:"Value",
      conversations:"Bot",
      carDocuments : "Dokumenty",
      mark:"Mark",
      registrNum:"Register num",
      color:"Color",
      students : "Students",
      model : "Model",
      settings : "Settings",
      logout : "Logout",
      logging : "Logined from",
      backgroundHealth : "Background health",
      firstName : "First name",
      lastName : "Last name",
      surname : "Last name",
      email : "Email",
      tel : "Tel",
      device : "Device",
      timeZone : "Time zone",
      timeZoneClear : "Clear",
      lastActivity : "Last activity",
      placeholderSearch : "search here ...",
      save : "Save",
      cancel : "Discard changes",
      unsavedChanges : "Unsaved changes",
      dateBirth:"Data of birth",
      position:"Position",
      pl:"Polish",
      en:"English",
      icons:"",
      feedbacks:{
        done:"Successfully done !",
        error:"Something went wrong !",
        wait:"Processing...",
        timeout:"The request time of server answering is out !",
        forbidden:"Access deny!",
      },
      name:"Name",
      description:"Description",
      responsibleId:"Responsible",
      responsible:"Responsible",
      facebook:"Facebook",
      hashCode:"Hash Code",
      conversationTypes:"Conversation Type",
      isPresent:"Published",
      level:"Level",
      typeId:"Type",
      answers:"Answers",
      estimationGroup:"Esti Group",
      answerTypeId:"Type",
      conversation:"Conversation",
      isLast:"Is last",
      text:"Text",
      point:"Scores",
      conversationId:"Conversation",
      isRight:"Is Right",
      url:"Url",
      fromId:"Coming from",
      nextId:"Going to",
      answerId:"Question",
      estimationFunction:"Estimation function",
      clasification:"Classification",
      outerUserId:"User from Telegram",
      isFinished:"Is finished",
      inProgress:"In progress",
      isBot:"Is Bot",
      flagId:"Flag Id",
      dateTime:"Time stamp",
      messages:"Messages",
      openConstructor:"Open in constructor",
      answerConnector:"Scores | Right | EstiGroup",
      date:'Date',
      course:'Plan',
      homework:'Homework',
      topicColumn:'Topic',
      exerciseHomeworkColumn:'Homework',
      comment:'Comment',
      notes:'Notes',
      saving:'Saving...',
      toPay:'To Pay',
      attendence:'Att-ce',
      extra:'Extra',
      student:'Student',
      duration:'Duration',
      start:'Start',
      end:'End',
      isPaid:'Is paid',
      schedule:'Schedule',
      ocupation:'Ocupation',
      location:'Location',
      gdocument:'G_Document',
      isForMe:'Is For Me',
      gDictionaryUa:'Dictionay UA',
      gDictionaryEng:'Dictionay Eng',
      algotithm:'Algorithm',
      find:'Find',
      stageType:"Pipeline type",
      dateFrom:"Date from",
      dateTo:"Date to",
      min:"min",
      cycledLesson:"Recurring lesson",
      noParticipantsShort:"No students",
      cycledLessonsFilter:"Recurring",
      dateRangeFilter:"Date range",
      scheduleCreateCycledNote:"This adds a new recurring lesson template - pick which weekday slot it repeats on.",
      isCycled:"Is cycled",
      hasBroadcast:"Has Broadcast",
      isActive:"Is active",
      active:"Active",
      inactive:"Inactive",
      Yes:"Yes",
      No:"No",
      "Empty list":"Empty list",
      "Loading ...":"Loading ...",
      "not selected":"Not selected",
      "clients conversations":"Bot conversations",
      "empty list":"No conversations yet",
      Public:'Public',
      Personal:'Personal',
      Tests:'Conversations',
      noTests:'No conversations yet',
      Lessons:"Lessons",
      "Sum price":"Sum price",
      syncCalendar:"Sync calendar",
      syncCalendarRunning:"Syncing...",
      syncCalendarDone:"Calendar synced",
      syncCalendarFailed:"Calendar sync failed",
      "Sum hours":"Sum hours",
      "Sum attendance":"Sum attendance",
      "Sum paid":"Sum paid",
      "Sum absence":"Sum absence",
       Profile:'Profile',
      Planned:'Planned',
      Words:'Words',
      Phrases:'Phrases',
      Courses:'Courses',
      visible:'Visible',
      hidden:'Hidden',
      addLinkCourse:'Add link',
      addCopyCourse:'Copy course',
      copyBadge:'Copy',
      linkBadge:'Link',
      noCourses:'No courses added yet',
      pendingApprovalHint:'Waiting for your approval',
      choosePlaceholderCourse:'Search course...',
      Platform:'Platform',
      grantPlatformAccess:'Grant platform access',
      grantPlatformAccessConfirm:'Create account',
      platformEmailLabel:'Email',
      platformNameLabel:'Display name',
      platformCreateError:'Could not create the account',
      platformAccountCreated:'Account created! Copy the link below and send it to the student:',
      copyActivationLink:'Copy activation link',
      platformSendLinkHint:'The student uses this link to set their own password and activate the account.',
      close:'Close',
      platformActive:'Platform connected',
      platformActiveHint:'The student has activated their platform account',
      platformPending:'Awaiting activation',
      weekDays:'Weekdays',
      planedStudentEventType:"Planned event type",
      "Easy test generation":"Easy test generation",
      "Ai test generation":"Ai test generation",
      Message:"Message",
      "Plan some event":"Plan an event",
      message:'Message',
      'Config planed event':"Event configuration",
      "Add day and time": "Add day and time",
      time:"Time",
      weekDay:"Weekday",
      Monday:"Monday",
      Tuesday:"Tuesday",
      Wednesday:"Wednesday",
      Thursday:"Thursday",
      Friday:"Friday",
      Saturday:"Saturday",
      Sunday:"Sunday",
      plannedEvents:{
        total:"Total",
        recurring:"Recurring",
        nextRun:"Next run",
        noNextRun:"Not scheduled",
        oneTime:"One-time",
        type:"Type",
        when:"When",
        noSchedule:"No schedule yet",
        deleteConfirm:"Delete this planned event?",
        hour:"Hour",
        minute:"Minute",
        testGenSectionTitle:"Test generation settings",
        testGenHint:"Blank field - uses the global setting from Quiz generation config",
        useGlobalDefault:"Use default",
        wordSourceModeLabel:"Word source",
      },
      groupsPage:{
        membersColumn:"Students",
        coursesColumn:"Courses",
        nextLessonColumn:"Next lesson",
        noNextLesson:"Not scheduled",
      },
      groupCard:{
        statsTotalLessons:"Total lessons",
        membersTitle:"Group students",
        addStudentPlaceholder:"Choose a student",
        addStudentButton:"Add",
        removeStudentConfirm:"Are you sure you want to remove this student from the group?",
        noMembers:"No students in this group yet",
        attendanceTitle:"Attendance timeline",
        attendancePresent:"Present",
        attendanceAbsent:"Absent",
        attendanceUnmarked:"Unmarked",
        testsTitle:"Conversations",
        noTests:"No conversations taken yet",
        pendingStatus:"Pending",
        backToTests:"Back to conversations",
        lessonsTitle:"Group lessons",
        noLessons:"No lessons yet",
        addLessonButton:"Add lesson",
        backToGroups:"Back to groups",
        coursesTitle:"Group courses",
      },
      tags:"Tags",
      clientsPage:{
        totalClients:"Total clients",
        newThisMonth:"New this month",
        chartTitle:"New clients — last 6 months",
        funnelTitle:"Clients by stage",
        allStageTypes:"All",
        addClient:"Add client",
        createClientTitle:"New client",
        tagsPlaceholder:"New tag...",
        noTags:"No tags",
        months:["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"],
      },
      weekDaysShort:["Mon","Tue","Wed","Thu","Fri","Sat","Sun"],
      weekDaysFull:["Monday","Tuesday","Wednesday","Thursday","Friday","Saturday","Sunday"],
      lessonParticipants:"Lesson participants",
      lessonWords:"Lesson words",
      lessonWordsEmpty:"No words yet",
      lessonWordsPlaceholder:"Search for a word...",
      lessonWordsAddBtn:"Add word",
      lessonWordsAddNewBtn:"Not in dictionary - create with AI",
      lessonPhrases:"Lesson phrases",
      lessonPhrasesEmpty:"No phrases yet",
      lessonPhrasesAddBtn:"Add phrase",
      lessonTopics:"Linked topics",
      lessonTopicsEmpty:"No topics linked yet",
      lessonTopicsAddPlaceholder:"Search for a topic...",
      lessonTopicsSingleParticipantOnly:"This lesson has no participants yet",
      lessonTopicsNoCourses:"Student has no assigned courses",
      lessonTopicsNoGroupCourses:"Group has no assigned courses",
      lessonTopicsNoCommonCourse:"These students share no common course",
      lessonTopicsPickStudent:"Whose workspace?",
      lessonTopicsNoStudentHasCourse:"None of this lesson's students has this course",
      workspaceTopicLessons:"Lessons",
      workspaceTopicLessonsEmpty:"No lessons linked yet",
      workspaceTopicLessonsAddPlaceholder:"Search lessons...",
      workspaceTopicLessonsNone:"Student has no lessons yet",
      lessonShowMore:"More settings",
      lessonHideMore:"Hide settings",
      lessonHomeworks:"Homework",
      lessonHomeworksEmpty:"No homework entries yet",
      lessonHomeworkAdd:"Add homework",
      lessonHomeworkNeedsTopic:"Attach a topic to the lesson first",
      lessonHomeworkTextPlaceholder:"Task description...",
      lessonHomeworkCreateExercise:"Create a new exercise",
      lessonHomeworkSearchExercise:"Search for an exercise...",
      lessonHomeworkExerciseDefaultName:"Exercise",
      lessonHomeworkMarkComplete:"Mark as done",
      lessonHomeworkMarkIncomplete:"Mark as not done",
      blockMarkerAdd:"Add a marker to this block",
      blockMarkerRemove:"Remove marker",
      blockMarkerHomePractice:"Practice at home",
      blockMarkerSkip:"Skip this block",
      blockMarkerImportant:"Very important",
      canvasOpen:"Open topic canvas",
      canvasBackToTopic:"Back to topic",
      canvasResetView:"reset",
      canvasToolSelect:"Select / move",
      canvasToolPencil:"Pencil",
      canvasToolRect:"Rectangle",
      canvasToolEllipse:"Ellipse",
      canvasToolArrow:"Arrow",
      canvasToolText:"Text",
      canvasToolImage:"Image",
      canvasToolVideoEmbed:"Embed video",
      canvasStudentCursor:"Student",
      canvasTeacherCursor:"Teacher",
      canvasDeleteElement:"Delete",
      canvasPresenceNoOne:"No one here yet",
      canvasPresenceCount:"{count} here",
      videoEmbedUrlLabel:"Video link",
      videoEmbedUrlPlaceholder:"https://www.youtube.com/watch?v=...",
      videoEmbedDescriptionLabel:"Description",
      videoEmbedDescriptionPlaceholder:"Optional",
      videoEmbedEmptyHint:"No video link yet",
      videoEmbedUnrecognized:"Couldn't recognize this link for embedding",
      videoEmbedSave:"Save",
      videoEmbedCancel:"Cancel",
      today:"Today",
      nextLesson:"Next lesson in",
      lastLesson:"Last lesson",
      daysShort:"d",
      hoursShort:"h",
      minutesShort:"min",
      monthsShort:"mo",
      lessonStartsIn:"Starts in",
      lessonEndedLabel:"Ended",
      agoSuffix:"ago",
      lessonInProgress:"In progress",
      "Daily schedule by":"Daily schedule for",
      noLessonsToday:"No lessons today",
      dailyScheduleStatPast:"past",
      dailyScheduleStatCurrent:"ongoing",
      dailyScheduleStatUpcoming:"upcoming",
      latestBotConversations:"Latest bot conversations",
      recentHomeworkTitle:"Recently completed homework",
      recentHomeworkEmpty:"No completed homework yet",
      recentHomeworkLesson:"Lesson",
      recentHomeworkTasks:"tasks",
      recentHomeworkScore:"Score",
      recentHomeworkOpen:"Open the student's course",
      recentHomeworkNoCourse:"Open homework preview",
      recentHomeworkJustNow:"just now",
      lessonsNoHomeworkTitle:"Last lessons without homework (past 3 days)",
      lessonsNoHomeworkEmpty:"No last lesson from the past 3 days is missing homework",
      lessonsNoHomeworkChip:"no homework",
      lessonsNoHomeworkOpen:"Open lesson",
      hourlyTelegramUsage:"Hourly Telegram bot chat usage",
      pendingApprovalsTitle:"Pending approvals from all students",
      pendingApprovalsEmpty:"Nothing waiting for your approval",
      questionsShort:"Q",
      wordsTab:{
        addExisting:"Add word to student",
        addNew:"Add new word",
        searchPlaceholder:"Search student's words...",
        searchHint:"Type at least one letter to search",
        aiAssist:"Fill in with AI",
        aiAssistGenerating:"Generating... (up to a minute)",
        aiAssistError:"Could not generate word attributes",
        spellingSuggestionLabel:"Did you mean:",
        primaryWords:"Words",
        secondaryWords:"Encountered as variants",
        noWords:"No words yet",
        sortNewest:"Newest",
        sortProficiency:"Proficiency",
        word:"Word",
        partOfSpeech:"Part of speech",
        frequency:"Frequency",
        ukTranslation:"Translation",
        translationsPlaceholder:"Add a meaning...",
        noTranslations:"No translations yet",
        transcriptionBr:"British transcription",
        transcriptionUs:"American transcription",
        tense:"Tense",
        form:"Form",
        proficiency:"Proficiency",
        allPartsOfSpeech:"All parts of speech",
        allTenses:"All tenses",
        allForms:"All forms",
      },
      irregularVerbsBoard:{
        tabLabel:"Irregular verbs",
        searchPlaceholder:"Search a verb...",
        noGroups:"No irregular verb groups yet",
        loadError:"Could not load irregular verbs - the server endpoint is not available",
        roleBase:"Base",
        rolePast:"Past",
        roleParticiple:"Participle",
        missingLabel:"Not learned yet",
      },
      screenshotImport:{
        title:"Import from a screenshot",
        pasteHint:"Paste an image (Ctrl+V) or choose a file",
        chooseFile:"Choose a file",
        recognize:"Recognize text",
        recognizing:"Recognizing...",
        textLabel:"Recognized text (you can correct it)",
        blanksCount:"Blanks found",
        lowConfidence:"Some words were recognized with low confidence - check the text",
        ocrUnavailable:"Text recognition is not available on the server",
        ocrFailed:"Could not recognize the text",
        generate:"Generate exercise",
        generating:"Generating...",
        draftTitle:"Draft exercise",
        nameLabel:"Exercise name",
        questionsCount:"Questions",
        createExercise:"Create exercise",
        creating:"Creating...",
        draftFailed:"The AI did not return a usable exercise - try again",
        createFailed:"Could not create the exercise",
        typeFillBlank:"Fill in the blanks",
        typeMultipleChoice:"Multiple choice",
        typeTrueFalse:"True / false",
        typeOrdering:"Ordering",
        typeMatching:"Matching",
        regenerate:"Regenerate",
        removeQuestion:"Remove",
        cancel:"Cancel",
        instructionLabel:"What should the exercise cover? (optional)",
        instructionPlaceholder:"e.g. only rhyming words, make the questions easier",
        sectionImage:"2. Image with text",
        sectionText:"3. Text (correct it or write your own)",
        sectionDraft:"4. AI draft",
        optional:"optional",
        textPlaceholder:"Paste or write the exercise text here…",
        editHint:"Edit the questions or remove the ones you do not need.",
        typeHeading:"Heading",
        typeText:"Text",
        typeList:"List",
        typeImage:"Image",
importButton:"Import from image",
        importTitle:"Import blocks from an image",
        addToExercise:"Add to exercise",
        addedCount:"Blocks added",
        imageTool:{
          button:"Image from clipboard",
          title:"Image from clipboard",
          zone:"Press Ctrl+V to paste a screenshot here",
          readClipboard:"Read clipboard",
          recognizing:"Recognizing...",
          copy:"Copy text",
          addAsText:"Add as text block",
          added:"Text block added",
          noImage:"There is no image in the clipboard",
          failed:"Could not recognize the text",
          close:"Close",
        },
      },
      phrasesTab:{
        textPlaceholder:"Write a phrase...",
        translationPlaceholder:"Translation (optional)",
        addBtn:"Add phrase",
        existingLabel:"Use an existing phrase:",
        noPhrasesYet:"No phrases yet",
        phraseTypePhrase:"Phrases",
        phraseTypeSentence:"Sentences",
      },
      platformTab:{
        pendingRequestsTitle:"Pending requests",
        noPendingRequests:"Nothing waiting for your approval",
        approve:"Show",
        reject:"Reject",
        actionsTitle:"Platform account actions",
        accountActiveLabel:"Account active",
        accountStatusOn:"Account is active",
        accountStatusOff:"Account is inactive",
        accountActiveError:"Could not update the account status",
        resetPasswordButton:"Password reset link",
        resetPasswordError:"Could not generate a reset link",
        resetPasswordHint:"Copy the link and pass it to the student yourself.",
      },
      sessionsPanel:{
        removeConfirm:"Remove this session?",
      },
      themeSettings:{
        title:"Colors",
        editingLight:"Editing: Light mode",
        editingDark:"Editing: Dark mode",
        groupBackgrounds:"Backgrounds",
        groupText:"Text",
        groupBorders:"Borders & lines",
        groupAccents:"Accents & shadows",
        bgColor:"Background",
        bgPrimaryColor:"Primary background",
        bgSecondaryFillColor:"Secondary fill",
        bgButtonsColor:"Buttons",
        bgModalColor:"Modal overlay",
        bgModalColor2:"Modal background",
        bgGreef:"Accent panel",
        bgTableColor:"Table background",
        bgInputsColor:"Input fields",
        bgInfopanels:"Info panels",
        bgElementColor:"Highlighted element",
        mainTextColor:"Main text",
        secondaryTextColor:"Secondary text",
        lighttextColor:"Accent text",
        borderColor:"Border",
        borderLeftColor:"Left border accent",
        linesColor:"Lines",
        secondayrBtns:"Secondary buttons",
        shadowColorOne:"Glow (subtle)",
        shadowColorTwo:"Glow (strong)",
        gradientLinear:"Linear",
        gradientRadial:"Radial",
        gradientCircle:"Circle",
        gradientEllipse:"Ellipse",
        gradientBarHint:"Click the bar to add a color, drag a dot to move it",
        toolbarTitle:"Tools",
        sessionsTitle:"Devices",
      },
      backgroundHealthPage:{
        title:"Background health",
        filterType:"Type",
        filterLevel:"Level",
        filterFrom:"From",
        filterTo:"To",
        allTypes:"All types",
        allLevels:"All levels",
        typeWordClassification:"Word classification",
        typeWordDiscovery:"Word discovery",
        typeLessonReminder:"Lesson reminders",
        typeCalendarSync:"Calendar sync",
        typePlannedEvents:"Planned events",
        typeCycledLessonPropagation:"Lesson propagation",
        typeTelegramSend:"Telegram sending",
        levelInfo:"Info",
        levelWarning:"Warning",
        levelError:"Error",
        viewRecent:"Recent",
        viewAggregated:"Aggregated",
        noEntries:"No log entries found",
        loading:"Loading...",
        loadError:"Failed to load",
        occurrences:"occurrences",
        lastSeen:"Last seen",
        details:"Details",
        settingsLinkTitle:"Background health",
        settingsLinkDescription:"View cron job logs, errors and Telegram delivery status",
      },
      vocabularyConfigPage:{
        settingsLinkTitle:"Vocabulary configuration",
        settingsLinkDescription:"Configure word-discovery AI, browse the dictionary, view Gemini usage",
        title:"Vocabulary configuration",
        configSectionTitle:"Cron configuration",
        classifyEnabled:"Classification enabled",
        classifyBatchSize:"Batch size",
        classifyMaxBatchesPerRun:"Max batches per run",
        classifyBatchHint:"Words pulled and processed per cron run - each run splits them into smaller AI requests automatically (not configurable here).",
        classifyIntervalMinutes:"Run every (minutes)",
        classifyConditionsTitle:"Word is pending if...",
        classifyCheckUnverified:"Not verified yet",
        classifyCheckMissingPartOfSpeech:"Missing part of speech",
        classifyCheckMissingFrequency:"Missing frequency",
        classifyCheckMissingTense:"Missing tense",
        classifyCheckMissingForm:"Missing form",
        classifyCheckMissingTranslation:"Missing translation",
        discoveryEnabled:"Discovery enabled",
        discoveryWordsPerRun:"Words per run",
        discoveryIntervalHours:"Run every (hours)",
        discoverySourceMode:"Word source",
        sourceModeAiGenerated:"AI-generated (by part of speech + frequency)",
        sourceModeIrregularVerbs:"Irregular verbs (reference list)",
        sourceModeTextSource:"From real text (Wikipedia)",
        irregularVerbsStatus:"{covered} of {total} irregular verb forms already in the dictionary",
        irregularVerbsNoReference:"Reference list not populated yet - will be fetched from AI on first run",
        refreshIrregularVerbs:"Refresh reference list",
        textSourceTodayTopic:"Today's topic",
        pasteTextTitle:"Or paste your own text",
        pasteTextPlaceholder:"Paste an article or any English text here - new words will be extracted from it",
        pasteTextButton:"Extract words from this text",
        discoveryPosMode:"Target part of speech",
        posModeAuto:"Auto-rotate daily",
        posModeFixed:"Fixed",
        discoveryFixedPartOfSpeech:"Fixed part of speech",
        discoveryMinFrequency:"Min frequency (Zipf)",
        discoveryMaxFrequency:"Max frequency (Zipf)",
        triggerClassify:"Run classification now",
        triggerDiscover:"Run discovery now",
        triggering:"Running...",
        resultPending:"pending",
        resultApplied:"applied",
        resultBatches:"batches",
        resultRequested:"requested",
        resultInserted:"inserted",
        progressTitle:"Live progress",
        progressBatch:"Batch",
        progressFailed:"failed",
        browserSectionTitle:"Dictionary",
        totalWordsLabel:"Total words",
        searchPlaceholder:"Search words...",
        allVerified:"All",
        verifiedYes:"Verified",
        verifiedNo:"Unverified",
        addWord:"Add word",
        studentCountHeader:"Learners",
        chartSectionTitle:"AI usage",
        effectivenessSectionTitle:"Effectiveness",
        range24h:"24h",
        range7d:"7d",
        range30d:"30d",
        statTotal:"Total requests",
        statSuccessRate:"Success rate",
        statErrors:"Errors",
        statAvgDuration:"Avg. response time",
        chartRequests:"Requests over time",
        chartDuration:"Response time over time",
        legendSuccess:"Success",
        legendError:"Error",
        showTable:"Show table",
        hideTable:"Hide table",
        noUsageData:"No API usage recorded yet",
      },
      aiConfigPage:{
        settingsLinkTitle:"AI provider",
        settingsLinkDescription:"Choose the active AI vendor and which model each one uses",
        title:"AI provider configuration",
        activeProvider:"Active provider",
        providerGemini:"Gemini (Google)",
        providerOpenai:"OpenAI",
        geminiModel:"Gemini model",
        openaiModel:"OpenAI model",
        groqModel:"Groq model",
        providerGroq:"Groq",
        activeBadge:"active",
        autoSwitchEnabled:"Auto-switch on rate limit",
        autoSwitchHintOn:"Tries Gemini first, then Groq (both free), and only falls back to OpenAI (paid) if both are currently rate-limited; switches back automatically once a breaker self-heals (24h). The provider selected above is ignored while this is on.",
        autoSwitchHintOff:"Off — the provider selected above is always used as-is, nothing switches automatically.",
        effectiveProviderLabel:"Currently active:",
        rateLimited:"Rate limited — disabled",
        rateLimitedSince:"since",
        clearRateLimit:"Clear rate limit",
        clearingRateLimit:"Clearing...",
      },
      apiUsageChart:{
        range24h:"24h",
        range7d:"7d",
        range30d:"30d",
        statTotal:"Total requests",
        statSuccessRate:"Success rate",
        statErrors:"Errors",
        statAvgDuration:"Avg. response time",
        chartRequests:"Requests over time",
        chartDuration:"Response time over time",
        legendSuccess:"Success",
        legendError:"Error",
        showTable:"Show table",
        hideTable:"Hide table",
        showRequests:"Show recent requests",
        hideRequests:"Hide recent requests",
        colTime:"Time",
        colContext:"Context",
        colStatus:"Status",
        colHttpCode:"HTTP code",
        colDuration:"Duration",
        requestBodyLabel:"Request",
        responseBodyLabel:"Response",
        noUsageData:"No API usage recorded yet",
      },
      wordCronEffectivenessChart:{
        classifyTitle:"Word updates (classification)",
        discoveryTitle:"New word discovery",
        legendSuccessClassify:"Updated",
        legendFailClassify:"Not updated",
        legendSuccessDiscovery:"Added",
        legendFailDiscovery:"Not added",
        statTotal:"Total words processed",
        statSuccessRate:"Success rate",
        colDate:"Date",
        colSuccess:"Success",
        colFail:"Fail",
        colRate:"Success rate",
        noData:"No data recorded yet",
      },
      quizGenerationConfigPage:{
        settingsLinkTitle:"Quiz generation",
        settingsLinkDescription:"Configure the automatic quiz-generation defaults and run it manually",
        title:"Quiz generation configuration",
        enabled:"Automatic generation enabled",
        wordSourceMode:"Default word source",
        sourceModeLastLesson:"Last lesson",
        sourceModeDateRange:"Date range",
        dateRangeDays:"Date range (days)",
        questionCount:"Question count",
        optionsPerQuestion:"Answer options per question",
        difficulty:"Difficulty",
        difficultyEasy:"Easy",
        difficultyMedium:"Medium",
        difficultyHard:"Hard",
        useAi:"Use AI to author questions",
        autoNaming:"Use AI to name and describe the quiz",
        textAnswerRatio:"Text-answer question ratio (%)",
        creativityMode:"AI question variety",
        creativityHint:"Steers the mix of AI question types (fill-in-the-blank, translation, part-of-speech) and how varied the wording is",
        creativityConservative:"Conservative - mostly fill-in-the-blank/translation",
        creativityBalanced:"Balanced - even mix of all types",
        creativityCreative:"Creative - max variety, more part-of-speech questions",
        triggerAuto:"Run now",
        triggering:"Running...",
        resultEventsTriggered:"events triggered",
        resultMessagesSent:"messages sent",
      },
      activeTasks:{
        trayTitle:"Active tasks",
        quizGenerationRunning:"Generating a test for",
        quizGenerationSuccess:"Test generated for",
        quizGenerationError:"Failed to generate a test for",
        viewInConstructor:"Open in constructor",
        dismiss:"Dismiss",
        toastSuccessTitle:"Success",
        toastErrorTitle:"Error",
      },
      studentsPage:{
        addStudent:"Add student",
        totalStudents:"Total students",
        activeStudents:"Active",
        testsLeaderTitle:"Most conversations completed",
        accuracyLeaderTitle:"Highest answer accuracy",
        lessonsLeaderTitle:"Most lessons in the last month",
        lessonsCalendarLeaderTitle:"Most lessons this calendar month",
        hoursShort:"h",
        filterAllStatus:"All",
        copied:"Copied",
      }
    },
    ua: {
      id: "Ідентифікатор",
      pages: {
        login: {
          loginTitle: "Увійти",
          loginPlaceholder: "логін...",
          passPlaceholder: "пароль...",
          loginButton: "Увійти"
        }
      },
      meta: "Ім'я",
      type: "Тип",
      answer: "Відповідь",
      emailVerificationPromptText: "Невірний формат електронної пошти!",
      clients: "Клієнти",
      client: "Клієнт",
      dashboard: "Панель",
      users: "Користувачі",
      pipeline: "Конвеєр",
      "pipeline creator": "Конвеєр конструктор",
      stagetype: "Конвеєр",
      schedule: "Розклад",
      projects: "Проєкти",
      project: "Проєкт",
      stage: "Етап",
      dLastContact: "Останній контакт",
      address: "Адреса",
      age: "Вік",
      probability: "Ймовірність",
      language: "Мова",
      category: "Категорія",
      product: "Продукт",
      fill: "...",
      groupe: "Група",
      groups: "Групи",
      resources: "Ресурси",
      teacher: "Викладач",
      price: "Ціна",
      source: "Джерело",
      gMeetId: "Gmeet ID",
      telegramUsername: "Телеграм",
      set: "Набори",
      grid: "Гра",
      modals: {
        conversationprogress: {
          createTitle: "Тут ви можете додати вікторину",
          updateDescription: "Тут ви можете редагувати вікторину",
          updateTitle: "Оновлення вікторини"
        },
        events: {
          createTitle: "Тут ви можете додати подію",
          updateDescription: "Тут ви можете редагувати подію",
          updateTitle: "Оновлення події"
        },
        answers: {
          createTitle: "Тут ви можете додати повідомлення",
          updateDescription: "Тут ви можете редагувати повідомлення",
          updateTitle: "Оновлення повідомлення"
        },
        conversations: {
          createTitle: "Тут ви можете додати розмову",
          updateDescription: "Тут ви можете редагувати розмову",
          updateTitle: "Оновлення розмови"
        },
        students: {
          createTitle: "Тут ви можете додати студента",
          updateDescription: "Тут ви можете редагувати студента",
          updateTitle: "Оновлення студента"
        },
        carDocuments: {
          createTitle: "Тут ви можете додати документ",
          updateDescription: "Поле не можна редагувати",
          updateTitle: "Редагування документа неможливе"
        },
        projects: {
          createTitle: "Тут ви можете додати проєкт",
          updateDescription: "Оновлення проєкту",
          updateTitle: "Тут ви можете редагувати проєкт"
        },
        users: {
          createTitle: "Тут ви можете додати користувача",
          updateDescription: "Тут ви можете редагувати користувача",
          updateTitle: "Оновлення користувача"
        },
        clients: {
          createTitle: "Тут ви можете додати клієнта",
          updateDescription: "Тут ви можете редагувати клієнта",
          updateTitle: "Оновлення клієнта"
        },
        lessons: {
          createTitle: "Тут ви можете додати урок",
          updateDescription: "Тут ви можете редагувати урок",
          updateTitle: "Оновлення уроку"
        },
        games: {
          createTitle: "Тут ви можете додати гру",
          updateDescription: "Тут ви можете редагувати гру",
          updateTitle: "Оновлення гри"
        },
        groups: {
          createTitle: "Тут ви можете додати групу",
          updateDescription: "Тут ви можете редагувати групу",
          updateTitle: "Оновлення групи"
        },
        quizGeneration: {
          title: "Згенерувати тест",
          lessonLabel: "Заняття",
          lessonDefault: "Без заняття (необов'язково)",
          additionalWordsLabel: "Додаткові слова",
          additionalWordsPlaceholder: "Пошук слова...",
          studentWordsLabel: "Обрати зі слів студента",
          noStudentWords: "У студента ще немає збережених слів",
          sourceHint: "Оберіть хоча б одне слово, або заняття, до якого вже додані слова",
          sourceRequiredError: "Спочатку оберіть хоча б одне слово",
          difficultyLabel: "Складність",
          difficultyDefault: "За замовчуванням",
          difficultyEasy: "Легко",
          difficultyMedium: "Середньо",
          difficultyHard: "Важко",
          questionCountLabel: "Кількість питань",
          questionCountPlaceholder: "За замовчуванням",
          optionsPerQuestionLabel: "Варіантів відповіді",
          optionsPerQuestionPlaceholder: "За замовчуванням",
          textAnswerRatioLabel: "Відсоток текстових питань (%)",
          textAnswerRatioPlaceholder: "За замовчуванням",
          useAiLabel: "Стиль питань",
          useAiDefault: "За замовчуванням",
          useAiOn: "Згенеровано AI",
          useAiOff: "Детермінований (без AI)",
          creativityLabel: "Різноманітність AI-питань",
          creativityDefault: "За замовчуванням",
          autoNamingLabel: "Використовувати AI для назви й опису тесту",
          titleLabel: "Назва",
          titlePlaceholder: "Назва тесту",
          descriptionLabel: "Опис",
          descriptionPlaceholder: "Опис тесту",
          generateBtn: "Згенерувати",
          generating: "Генерується...",
          genericError: "Не вдалося згенерувати тест",
          minimizeTooltip: "Запустити у фоні"
        }
      },
      tasks: "Завдання",
      games: "Ігри",
      value: "Значення",
      conversations: "Бот",
      carDocuments: "Документи",
      mark: "Оцінка",
      registrNum: "Реєстраційний номер",
      color: "Колір",
      students: "Студенти",
      model: "Модель",
      settings: "Налаштування",
      logout: "Вийти",
      logging: "Увійшов з",
      backgroundHealth: "Стан фонових процесів",
      firstName: "Ім’я",
      lastName: "Прізвище",
      surname: "Прізвище",
      email: "Електронна пошта",
      tel: "Телефон",
      device: "Пристрій",
      timeZone: "Часовий пояс",
      timeZoneClear: "Очистити",
      lastActivity: "Остання активність",
      placeholderSearch: "пошук тут ...",
      save: "Зберегти",
      cancel: "Скасувати зміни",
      unsavedChanges: "Незбережені зміни",
      dateBirth: "Дата народження",
      position: "Посада",
      pl: "Польська",
      en: "Англійська",
      icons: "",
      feedbacks: {
        done: "Успішно виконано!",
        error: "Щось пішло не так!",
        wait: "Обробка...",
        timeout: "Час очікування відповіді сервера вичерпано!",
        forbidden: "Доступ заборонено!"
      },
      name: "Назва",
      description: "Опис",
      responsibleId: "Відповідальний",
      responsible: "Відповідальний",
      facebook: "Facebook",
      hashCode: "Хеш-код",
      conversationTypes: "Тип розмови",
      isPresent: "Опубліковано",
      level: "Рівень",
      typeId: "Тип",
      answers: "Відповіді",
      estimationGroup: "Група оцінки",
      answerTypeId: "Тип",
      conversation: "Розмова",
      isLast: "Останній",
      text: "Текст",
      point: "Бали",
      conversationId: "Розмова",
      isRight: "Правильна",
      url: "Посилання",
      fromId: "Звідки",
      nextId: "Куди",
      answerId: "Питання",
      estimationFunction: "Функція оцінки",
      clasification: "Класифікація",
      outerUserId: "Користувач з Телеграму",
      isFinished: "Завершено",
      inProgress: "В процесі",
      isBot: "Це бот",
      flagId: "Ідентифікатор прапора",
      dateTime: "Часова мітка",
      messages: "Повідомлення",
      openConstructor: "Відкрити в конструкторі",
      answerConnector: "Бали | Правильність | Група оцінки",
      date: "Дата",
      course: "План",
      homework: "Домашнє завдання",
      topicColumn: "Тема",
      exerciseHomeworkColumn: "Домашнє завдання",
      comment: "Коментар",
      notes: "Нотатки",
      saving: "Зберігаю...",
      toPay: "До оплати",
      attendence: "Відвідування",
      extra: "Додатково",
      student: "Студент",
      duration: "Тривалість",
      start: "Початок",
      end: "Кінець",
      isPaid: "Оплачено",
      schedule: "Розклад",
      ocupation: "Зайнятість",
      location: "Місцезнаходження",
      gdocument: "G_Документ",
      isForMe: "Для мене",
      gDictionaryUa: "Словник UA",
      gDictionaryEng: "Словник ENG",
      algotithm: "Алгоритм",
      find: "Знайти",
      dateFrom: "Дата від",
      dateTo: "Дата до",
      min: "хв",
      cycledLesson: "Циклічне заняття",
      noParticipantsShort: "Без учнів",
      cycledLessonsFilter: "Циклічні",
      dateRangeFilter: "Період дат",
      scheduleCreateCycledNote: "Це додає новий шаблон циклічного заняття - оберіть день тижня, на який воно повторюється.",
      isCycled: "Повторювана",
      hasBroadcast: "Повідомлення з бота",
      isActive: "Активний",
      active:"Активний",
      inactive:"Неактивний",
      Yes:"Так",
      No:"Ні",
      "Empty list":"Пустий список",
      "Loading ...":"Завантаження ...",
      "not selected":"Не обрано",
      Public:'Загальні',
      Personal:'Особисті',
      Tests:'Розмови',
      noTests:'Розмов ще не проходили',
      Lessons:"Заняття",
      "Sum price":"Сумарні кошти",
      syncCalendar:"Синхронізувати календар",
      syncCalendarRunning:"Синхронізація...",
      syncCalendarDone:"Календар синхронізовано",
      syncCalendarFailed:"Не вдалося синхронізувати календар",
      "Sum hours":"Сумарні години",
      "Sum attendance":"Відвідувальність",
      "Sum paid":"Оплачено занять",
      "Sum absence":"Пропущено",
      Profile:'Профіль',
      Planned:'Заплановане',
      Words:'Слова',
      Phrases:'Фрази',
      Courses:'Курси',
      visible:'Видимо',
      hidden:'Приховано',
      addLinkCourse:'Додати посилання',
      addCopyCourse:'Скопіювати курс',
      copyBadge:'Копія',
      linkBadge:'Посилання',
      noCourses:'Курсів ще не додано',
      pendingApprovalHint:'Очікує вашого підтвердження',
      choosePlaceholderCourse:'Пошук курсу...',
      Platform:'Платформа',
      grantPlatformAccess:'Надати доступ до платформи',
      grantPlatformAccessConfirm:'Створити акаунт',
      platformEmailLabel:'Електронна пошта',
      platformNameLabel:'Ім\'я для платформи',
      platformCreateError:'Не вдалося створити акаунт',
      platformAccountCreated:'Акаунт створено! Скопіюйте посилання нижче та надішліть його студенту:',
      copyActivationLink:'Скопіювати посилання активації',
      platformSendLinkHint:'За цим посиланням студент встановить власний пароль і активує акаунт.',
      close:'Закрити',
      platformActive:'Платформу підключено',
      platformActiveHint:'Студент активував свій акаунт на платформі',
      platformPending:'Очікує активації',
      weekDays:'Дні тижня',
      planedStudentEventType:"Тип планованої події",
      "Easy test generation":"Просте генерування тестів",
      "Medium test generation":"Середнє генерування тестів",
      "Hard test generation":"Заучування генерування тестів",
      "Ai test generation":"Генерування тесту нейромережею",
      Message:"Повідомлення",
      "Plan some event":"Заплануй подію",
      message:'Повідомлення',
      'Config planed event':"Конфігурація події",
      "Add day and time": "Додай день та час",
      time:"Час",
      weekDay:"День тижня",
      Monday:"Понеділок",
      Tuesday:"Вівторок",
      Wednesday:"Середа",
      Thursday:"Четвер",
      Friday:"Пятниця",
      Saturday:"Суббота",
      Sunday:"Неділя",
      plannedEvents:{
        total:"Всього",
        recurring:"Циклічних",
        nextRun:"Наступний запуск",
        noNextRun:"Не заплановано",
        oneTime:"Одноразово",
        type:"Тип",
        when:"Коли",
        noSchedule:"Розклад ще не задано",
        deleteConfirm:"Видалити цю заплановану подію?",
        hour:"Година",
        minute:"Хвилина",
        testGenSectionTitle:"Налаштування генерації тесту",
        testGenHint:"Порожнє поле - використовується загальне налаштування з конфігурації генерації тестів",
        useGlobalDefault:"За замовчуванням",
        wordSourceModeLabel:"Джерело слів",
      },
      priceIndividual:"Ціна за індивідуальне",
      priceGroup:"Ціна за групове",
      stageType:"Тип конвеєра",
      dAdd:"Дата додання",
      "clients conversations":"Розмови з ботом",
      "empty list":"На разі список пустий",
      "time add": "Час додання",
      stageTypeId: "Тип конвеєра",
      conversationprogress: "Розмови",
      Bot:"Бот",
      "Daily schedule by": "Денний розклад за",
      groupsPage:{
        membersColumn:"Учнів",
        coursesColumn:"Курси",
        nextLessonColumn:"Наступне заняття",
        noNextLesson:"Не заплановано",
      },
      groupCard:{
        statsTotalLessons:"Всього занять",
        membersTitle:"Учні групи",
        addStudentPlaceholder:"Оберіть студента",
        addStudentButton:"Додати cтудента",
        removeStudentConfirm:"Ви впевнені, що хочете прибрати цього учня з групи?",
        noMembers:"У групі ще немає учнів",
        attendanceTitle:"Відвідування по заняттях",
        attendancePresent:"Був(-ла)",
        attendanceAbsent:"Відсутній(-я)",
        attendanceUnmarked:"Не відмічено",
        testsTitle:"Розмови",
        noTests:"Розмов ще не проходили",
        pendingStatus:"В процесі",
        backToTests:"До списку розмов",
        lessonsTitle:"Заняття групи",
        noLessons:"Занять ще немає",
        addLessonButton:"Додати заняття",
        backToGroups:"До груп",
        coursesTitle:"Курси групи"
      },
      tags:"Теги",
      clientsPage:{
        totalClients:"Всього клієнтів",
        newThisMonth:"Нові цього місяця",
        chartTitle:"Нові клієнти — останні 6 місяців",
        funnelTitle:"Клієнти за етапом",
        allStageTypes:"Всі",
        addClient:"Додати клієнта",
        createClientTitle:"Новий клієнт",
        tagsPlaceholder:"Новий тег...",
        noTags:"Немає тегів",
        months:["Січ","Лют","Бер","Кві","Тра","Чер","Лип","Сер","Вер","Жов","Лис","Гру"],
      },
      weekDaysShort:["Пн","Вт","Ср","Чт","Пт","Сб","Нд"],
      weekDaysFull:["Понеділок","Вівторок","Середа","Четвер","П'ятниця","Субота","Неділя"],
      lessonParticipants:"Учасники заняття",
      lessonWords:"Слова заняття",
      lessonWordsEmpty:"Ще немає слів",
      lessonWordsPlaceholder:"Пошук слова...",
      lessonWordsAddBtn:"Додати слово",
      lessonWordsAddNewBtn:"Немає в словнику - створити через AI",
      lessonPhrases:"Фрази заняття",
      lessonPhrasesEmpty:"Ще немає фраз",
      lessonPhrasesAddBtn:"Додати фразу",
      lessonTopics:"Прив'язані теми",
      lessonTopicsEmpty:"Ще немає прив'язаних тем",
      lessonTopicsAddPlaceholder:"Пошук теми...",
      lessonTopicsSingleParticipantOnly:"У цього заняття ще немає учасників",
      lessonTopicsNoCourses:"У студента немає призначених курсів",
      lessonTopicsNoGroupCourses:"У групи немає призначених курсів",
      lessonTopicsNoCommonCourse:"У цих студентів немає спільного курсу",
      lessonTopicsPickStudent:"Чий workspace відкрити?",
      lessonTopicsNoStudentHasCourse:"Жоден студент цього заняття не має цього курсу",
      workspaceTopicLessons:"Заняття",
      workspaceTopicLessonsEmpty:"Ще немає прив'язаних занять",
      workspaceTopicLessonsAddPlaceholder:"Пошук занять...",
      workspaceTopicLessonsNone:"У студента ще немає занять",
      lessonShowMore:"Додаткові налаштування",
      lessonHideMore:"Сховати налаштування",
      lessonHomeworks:"Домашні завдання",
      lessonHomeworksEmpty:"Ще немає домашніх завдань",
      lessonHomeworkAdd:"Додати домашнє завдання",
      lessonHomeworkNeedsTopic:"Спочатку прив'яжіть тему до заняття",
      lessonHomeworkTextPlaceholder:"Опис завдання...",
      lessonHomeworkCreateExercise:"Створити нову вправу",
      lessonHomeworkSearchExercise:"Пошук вправи...",
      lessonHomeworkExerciseDefaultName:"Вправа",
      lessonHomeworkMarkComplete:"Позначити виконаним",
      lessonHomeworkMarkIncomplete:"Позначити невиконаним",
      blockMarkerAdd:"Додати маркер до блоку",
      blockMarkerRemove:"Прибрати маркер",
      blockMarkerHomePractice:"Опрацювати вдома",
      blockMarkerSkip:"Пропускаємо цей блок",
      blockMarkerImportant:"Дуже важливо",
      canvasOpen:"Відкрити канвас теми",
      canvasBackToTopic:"Назад до теми",
      canvasResetView:"скинути",
      canvasToolSelect:"Вибір / переміщення",
      canvasToolPencil:"Олівець",
      canvasToolRect:"Прямокутник",
      canvasToolEllipse:"Еліпс",
      canvasToolArrow:"Стрілка",
      canvasToolText:"Текст",
      canvasToolImage:"Зображення",
      canvasToolVideoEmbed:"Вбудувати відео",
      canvasStudentCursor:"Студент",
      canvasTeacherCursor:"Викладач",
      canvasDeleteElement:"Видалити",
      canvasPresenceNoOne:"Ще нікого немає",
      canvasPresenceCount:"{count} тут",
      videoEmbedUrlLabel:"Посилання на відео",
      videoEmbedUrlPlaceholder:"https://www.youtube.com/watch?v=...",
      videoEmbedDescriptionLabel:"Опис",
      videoEmbedDescriptionPlaceholder:"Необовʼязково",
      videoEmbedEmptyHint:"Ще немає посилання на відео",
      videoEmbedUnrecognized:"Не вдалося розпізнати посилання для вбудовування",
      videoEmbedSave:"Зберегти",
      videoEmbedCancel:"Скасувати",
      today:"Сьогодні",
      nextLesson:"Наступний урок за",
      lastLesson:"Останній урок",
      daysShort:"дн",
      hoursShort:"год",
      minutesShort:"хв",
      monthsShort:"міс",
      lessonStartsIn:"Розпочнеться за",
      lessonEndedLabel:"Завершився",
      agoSuffix:"тому",
      lessonInProgress:"Триває зараз",
      noLessonsToday:"Сьогодні немає занять",
      dailyScheduleStatPast:"минуло",
      dailyScheduleStatCurrent:"триває",
      dailyScheduleStatUpcoming:"попереду",
      latestBotConversations:"Останньо створені бот-розмови",
      recentHomeworkTitle:"Останні виконані домашні завдання",
      recentHomeworkEmpty:"Виконаних домашніх завдань ще немає",
      recentHomeworkLesson:"Урок",
      recentHomeworkTasks:"завд.",
      recentHomeworkScore:"Результат",
      recentHomeworkOpen:"Відкрити курс студента",
      recentHomeworkNoCourse:"Відкрити перегляд домашнього завдання",
      recentHomeworkJustNow:"щойно",
      lessonsNoHomeworkTitle:"Останні заняття без домашнього завдання (3 дні)",
      lessonsNoHomeworkEmpty:"За останні 3 дні всі останні заняття мають домашнє завдання",
      lessonsNoHomeworkChip:"без ДЗ",
      lessonsNoHomeworkOpen:"Відкрити заняття",
      hourlyTelegramUsage:"Погодинне використання чату з телеграм ботом",
      pendingApprovalsTitle:"Очікують підтвердження від усіх студентів",
      pendingApprovalsEmpty:"Немає нічого, що очікує на ваше підтвердження",
      questionsShort:"пит.",
      wordsTab:{
        addExisting:"Додати слово студенту",
        addNew:"Додати нове слово",
        searchPlaceholder:"Пошук слів студента",
        searchHint:"Введіть хоча б одну літеру для пошуку",
        aiAssist:"Заповнити за допомогою AI",
        aiAssistGenerating:"Генерую... (до хвилини)",
        aiAssistError:"Не вдалося згенерувати параметри слова",
        spellingSuggestionLabel:"Можливо ви мали на увазі:",
        primaryWords:"Слова",
        secondaryWords:"Зустрічались як варіанти",
        noWords:"Ще немає слів",
        sortNewest:"Найновіші",
        sortProficiency:"Успішність",
        word:"Слово",
        partOfSpeech:"Частина мови",
        frequency:"Частота",
        ukTranslation:"Переклад",
        translationsPlaceholder:"Додати значення...",
        noTranslations:"Ще немає перекладів",
        transcriptionBr:"Британська транскрипція",
        transcriptionUs:"Американська транскрипція",
        tense:"Час",
        form:"Форма",
        proficiency:"Успішність",
        allPartsOfSpeech:"Всі частини мови",
        allTenses:"Всі часи",
        allForms:"Всі форми",
      },
      irregularVerbsBoard:{
        tabLabel:"Неправильні дієслова",
        searchPlaceholder:"Пошук дієслова...",
        noGroups:"Ще немає груп неправильних дієслів",
        loadError:"Не вдалося завантажити неправильні дієслова - серверний ендпоінт недоступний",
        roleBase:"Базова форма",
        rolePast:"Минулий час",
        roleParticiple:"Дієприкметник",
        missingLabel:"Ще не вивчено",
      },
      screenshotImport:{
        title:"Імпорт зі скриншота",
        pasteHint:"Вставте зображення (Ctrl+V) або оберіть файл",
        chooseFile:"Обрати файл",
        recognize:"Розпізнати текст",
        recognizing:"Розпізнавання...",
        textLabel:"Розпізнаний текст (можна виправити)",
        blanksCount:"Знайдено пропусків",
        lowConfidence:"Частину слів розпізнано з низькою впевненістю - перевірте текст",
        ocrUnavailable:"Розпізнавання тексту недоступне на сервері",
        ocrFailed:"Не вдалося розпізнати текст",
        generate:"Згенерувати вправу",
        generating:"Генерація...",
        draftTitle:"Чернетка вправи",
        nameLabel:"Назва вправи",
        questionsCount:"Питань",
        createExercise:"Створити вправу",
        creating:"Створення...",
        draftFailed:"AI не повернув придатну вправу - спробуйте ще раз",
        createFailed:"Не вдалося створити вправу",
        typeFillBlank:"Заповнити пропуски",
        typeMultipleChoice:"Вибір варіанта",
        typeTrueFalse:"Так / ні",
        typeOrdering:"Послідовність",
        typeMatching:"Пари",
        regenerate:"Згенерувати ще раз",
        removeQuestion:"Видалити",
        cancel:"Скасувати",
        instructionLabel:"Про що має бути вправа? (необов'язково)",
        instructionPlaceholder:"наприклад: лише слова-рими, зробити питання простішими",
        sectionImage:"2. Зображення з текстом",
        sectionText:"3. Текст (можна виправити або написати самому)",
        sectionDraft:"4. Чернетка від AI",
        optional:"необов'язково",
        textPlaceholder:"Вставте або напишіть текст вправи тут…",
        editHint:"Змініть текст питань або видаліть зайві.",
        typeHeading:"Заголовок",
        typeText:"Текст",
        typeList:"Список",
        typeImage:"Зображення",
importButton:"Імпорт з зображення",
        importTitle:"Імпорт блоків із зображення",
        addToExercise:"Додати до вправи",
        addedCount:"Додано блоків",
        imageTool:{
          button:"Зображення зі буфера",
          title:"Зображення зі буфера",
          zone:"Натисніть Ctrl+V, щоб вставити скриншот сюди",
          readClipboard:"Прочитати буфер",
          recognizing:"Розпізнавання...",
          copy:"Копіювати текст",
          addAsText:"Додати як текстовий блок",
          added:"Текстовий блок додано",
          noImage:"У буфері немає зображення",
          failed:"Не вдалося розпізнати текст",
          close:"Закрити",
        },
      },
      phrasesTab:{
        textPlaceholder:"Напишіть фразу...",
        translationPlaceholder:"Переклад (необов'язково)",
        addBtn:"Додати фразу",
        existingLabel:"Використати існуючу фразу:",
        noPhrasesYet:"Ще немає фраз",
        phraseTypePhrase:"Фрази",
        phraseTypeSentence:"Речення",
      },
      platformTab:{
        pendingRequestsTitle:"Очікують підтвердження",
        noPendingRequests:"Немає нічого, що очікує на ваше підтвердження",
        approve:"Показати",
        reject:"Відхилити",
        actionsTitle:"Дії з обліковим записом платформи",
        accountActiveLabel:"Обліковий запис активний",
        accountStatusOn:"Обліковий запис активний",
        accountStatusOff:"Обліковий запис неактивний",
        accountActiveError:"Не вдалося змінити статус облікового запису",
        resetPasswordButton:"Посилання скидання пароля",
        resetPasswordError:"Не вдалося створити посилання",
        resetPasswordHint:"Скопіюйте посилання і передайте студенту самостійно.",
      },
      sessionsPanel:{
        removeConfirm:"Видалити цю сесію?",
      },
      themeSettings:{
        title:"Кольори",
        editingLight:"Редагування: світлий режим",
        editingDark:"Редагування: темний режим",
        groupBackgrounds:"Фони",
        groupText:"Текст",
        groupBorders:"Обрамлення та лінії",
        groupAccents:"Акценти та світіння",
        bgColor:"Фон",
        bgPrimaryColor:"Основний фон",
        bgSecondaryFillColor:"Другорядна заливка",
        bgButtonsColor:"Кнопки",
        bgModalColor:"Підкладка модального вікна",
        bgModalColor2:"Фон модального вікна",
        bgGreef:"Акцентна панель",
        bgTableColor:"Фон таблиці",
        bgInputsColor:"Поля вводу",
        bgInfopanels:"Інформаційні панелі",
        bgElementColor:"Виділений елемент",
        mainTextColor:"Основний текст",
        secondaryTextColor:"Другорядний текст",
        lighttextColor:"Акцентний текст",
        borderColor:"Обрамлення",
        borderLeftColor:"Ліва межа-акцент",
        linesColor:"Лінії",
        secondayrBtns:"Другорядні кнопки",
        shadowColorOne:"Світіння (слабке)",
        shadowColorTwo:"Світіння (сильне)",
        gradientLinear:"Лінійний",
        gradientRadial:"Радіальний",
        gradientCircle:"Коло",
        gradientEllipse:"Еліпс",
        gradientBarHint:"Клікніть на смужку щоб додати колір, перетягніть крапку щоб змінити позицію",
        toolbarTitle:"Інструменти",
        sessionsTitle:"Пристрої",
      },
      backgroundHealthPage:{
        title:"Стан фонових процесів",
        filterType:"Тип",
        filterLevel:"Рівень",
        filterFrom:"Від",
        filterTo:"До",
        allTypes:"Всі типи",
        allLevels:"Всі рівні",
        typeWordClassification:"Класифікація слів",
        typeWordDiscovery:"Пошук нових слів",
        typeLessonReminder:"Нагадування про заняття",
        typeCalendarSync:"Синхронізація календаря",
        typePlannedEvents:"Заплановані події",
        typeCycledLessonPropagation:"Перенесення занять",
        typeTelegramSend:"Розсилка Telegram",
        levelInfo:"Інфо",
        levelWarning:"Попередження",
        levelError:"Помилка",
        viewRecent:"Останні",
        viewAggregated:"Згруповані",
        noEntries:"Записів не знайдено",
        loading:"Завантаження...",
        loadError:"Не вдалося завантажити",
        occurrences:"випадків",
        lastSeen:"Востаннє",
        details:"Деталі",
        settingsLinkTitle:"Стан фонових процесів",
        settingsLinkDescription:"Перегляд логів кронів, помилок та статусу розсилок Telegram",
      },
      vocabularyConfigPage:{
        settingsLinkTitle:"Конфігурація словника",
        settingsLinkDescription:"Налаштування AI для пошуку слів, перегляд словника, статистика Gemini",
        title:"Конфігурація словника",
        configSectionTitle:"Конфігурація кронів",
        classifyEnabled:"Класифікація увімкнена",
        classifyBatchSize:"Розмір пачки",
        classifyMaxBatchesPerRun:"Макс. пачок за раз",
        classifyBatchHint:"Скільки слів береться і обробляється за один запуск крону - усередині кожен запуск автоматично ділить їх на менші запити до AI (тут це не налаштовується).",
        classifyIntervalMinutes:"Запускати кожні (хв)",
        classifyConditionsTitle:"Слово в черзі, якщо...",
        classifyCheckUnverified:"Ще не перевірено",
        classifyCheckMissingPartOfSpeech:"Відсутня частина мови",
        classifyCheckMissingFrequency:"Відсутня частота",
        classifyCheckMissingTense:"Відсутній час",
        classifyCheckMissingForm:"Відсутня форма",
        classifyCheckMissingTranslation:"Відсутній переклад",
        discoveryEnabled:"Пошук нових слів увімкнено",
        discoveryWordsPerRun:"Слів за раз",
        discoveryIntervalHours:"Запускати кожні (год)",
        discoverySourceMode:"Джерело слів",
        sourceModeAiGenerated:"Згенеровані AI (за частиною мови + частотою)",
        sourceModeIrregularVerbs:"Неправильні дієслова (довідниковий список)",
        sourceModeTextSource:"З реального тексту (Wikipedia)",
        irregularVerbsStatus:"{covered} з {total} форм неправильних дієслів вже у словнику",
        irregularVerbsNoReference:"Довідниковий список ще не заповнено - буде отриманий від AI при першому запуску",
        refreshIrregularVerbs:"Оновити довідниковий список",
        textSourceTodayTopic:"Сьогоднішня тема",
        pasteTextTitle:"Або вставте власний текст",
        pasteTextPlaceholder:"Вставте статтю чи будь-який англійський текст - з нього будуть виділені нові слова",
        pasteTextButton:"Виділити слова з цього тексту",
        discoveryPosMode:"Цільова частина мови",
        posModeAuto:"Автоматична ротація щодня",
        posModeFixed:"Фіксована",
        discoveryFixedPartOfSpeech:"Фіксована частина мови",
        discoveryMinFrequency:"Мін. частота (Zipf)",
        discoveryMaxFrequency:"Макс. частота (Zipf)",
        botCaptureTitle:"Захоплення слів з бота",
        botCaptureEnabled:"Оцінювати слова з відповідей у Telegram-квізах",
        botCaptureDescription:"Коли учень відповідає на квіз-питання в Telegram, автоматично оновлювати його рівень володіння відповідним словом. Вимкнено за замовчуванням.",
        botCaptureNewWords:"Зберігати нові випадкові слова з тестів",
        botCaptureNewWordsDescription:"Коли вимкнено, тест лише підвищує або знижує рівень володіння вже відомими словами - нові слова, випадково побачені під час проходження тесту (наприклад, варіанти відповідей), у словник не додаються. Вимкнено за замовчуванням. Діє лише коли захоплення слів з бота увімкнено вище.",
        platformCaptureTitle:"Захоплення слів з платформи",
        platformCaptureEnabled:"Оцінювати слова з відповідей на платформі",
        platformCaptureDescription:"Коли учень відповідає на питання тесту чи розмови на платформі, автоматично оновлювати його рівень володіння відповідним словом. Вимкнено за замовчуванням.",
        platformCaptureNewWords:"Зберігати нові випадкові слова з тестів",
        platformCaptureNewWordsDescription:"Коли вимкнено, тест лише підвищує або знижує рівень володіння вже відомими словами - нові слова, випадково побачені під час проходження тесту, у словник не додаються. Вимкнено за замовчуванням. Діє лише коли захоплення слів з платформи увімкнено вище.",
        triggerClassify:"Запустити класифікацію зараз",
        triggerDiscover:"Запустити пошук зараз",
        triggering:"Виконується...",
        resultPending:"в очікуванні",
        resultApplied:"застосовано",
        resultBatches:"пачок",
        resultRequested:"запитано",
        resultInserted:"додано",
        progressTitle:"Прогрес наживо",
        progressBatch:"Пачка",
        progressFailed:"помилка",
        browserSectionTitle:"Словник",
        totalWordsLabel:"Всього слів",
        searchPlaceholder:"Пошук слів...",
        allVerified:"Всі",
        verifiedYes:"Перевірені",
        verifiedNo:"Неперевірені",
        addWord:"Додати слово",
        studentCountHeader:"Використовують",
        chartSectionTitle:"Використання AI",
        effectivenessSectionTitle:"Ефективність",
        range24h:"24г",
        range7d:"7д",
        range30d:"30д",
        statTotal:"Всього запитів",
        statSuccessRate:"Успішність",
        statErrors:"Помилки",
        statAvgDuration:"Сер. час відповіді",
        chartRequests:"Запити за часом",
        chartDuration:"Час відповіді за часом",
        legendSuccess:"Успішно",
        legendError:"Помилка",
        showTable:"Показати таблицю",
        hideTable:"Сховати таблицю",
        noUsageData:"Ще немає даних про використання API",
      },
      aiConfigPage:{
        settingsLinkTitle:"AI провайдер",
        settingsLinkDescription:"Обрати активного постачальника AI та модель для кожного з них",
        title:"Конфігурація AI провайдера",
        activeProvider:"Активний провайдер",
        providerGemini:"Gemini (Google)",
        providerOpenai:"OpenAI",
        geminiModel:"Модель Gemini",
        openaiModel:"Модель OpenAI",
        groqModel:"Модель Groq",
        providerGroq:"Groq",
        activeBadge:"активний",
        autoSwitchEnabled:"Автоперемикання при вичерпанні ліміту",
        autoSwitchHintOn:"Спочатку пробує Gemini, потім Groq (обидва безкоштовні), і лише якщо обидва зараз вичерпали ліміт — переходить на OpenAI (платний); повертається назад автоматично, щойно один з breaker'ів самовідновиться (24г). Обраний вище провайдер ігнорується, поки це увімкнено.",
        autoSwitchHintOff:"Вимкнено — завжди використовується обраний вище провайдер, нічого не перемикається автоматично.",
        effectiveProviderLabel:"Зараз активний:",
        rateLimited:"Ліміт запитів — вимкнено",
        rateLimitedSince:"з",
        clearRateLimit:"Скасувати обмеження",
        clearingRateLimit:"Скасовую...",
      },
      apiUsageChart:{
        range24h:"24г",
        range7d:"7д",
        range30d:"30д",
        statTotal:"Всього запитів",
        statSuccessRate:"Успішність",
        statErrors:"Помилки",
        statAvgDuration:"Сер. час відповіді",
        chartRequests:"Запити за часом",
        chartDuration:"Час відповіді за часом",
        legendSuccess:"Успішно",
        legendError:"Помилка",
        showTable:"Показати таблицю",
        hideTable:"Сховати таблицю",
        showRequests:"Показати останні запити",
        hideRequests:"Сховати останні запити",
        colTime:"Час",
        colContext:"Контекст",
        colStatus:"Статус",
        colHttpCode:"HTTP код",
        colDuration:"Тривалість",
        requestBodyLabel:"Запит",
        responseBodyLabel:"Відповідь",
        noUsageData:"Ще немає даних про використання API",
      },
      wordCronEffectivenessChart:{
        classifyTitle:"Оновлення слів (класифікація)",
        discoveryTitle:"Додавання нових слів",
        legendSuccessClassify:"Оновлено",
        legendFailClassify:"Не оновлено",
        legendSuccessDiscovery:"Додано",
        legendFailDiscovery:"Не додано",
        statTotal:"Всього оброблено слів",
        statSuccessRate:"Успішність",
        colDate:"Дата",
        colSuccess:"Успішно",
        colFail:"Невдало",
        colRate:"Успішність",
        noData:"Ще немає даних",
      },
      quizGenerationConfigPage:{
        settingsLinkTitle:"Генерація тестів",
        settingsLinkDescription:"Налаштування автоматичної генерації тестів та ручний запуск",
        title:"Конфігурація генерації тестів",
        enabled:"Автоматична генерація увімкнена",
        wordSourceMode:"Джерело слів за замовчуванням",
        sourceModeLastLesson:"Останнє заняття",
        sourceModeDateRange:"Діапазон дат",
        dateRangeDays:"Діапазон дат (днів)",
        questionCount:"Кількість питань",
        optionsPerQuestion:"Варіантів відповіді на питання",
        difficulty:"Складність",
        difficultyEasy:"Легко",
        difficultyMedium:"Середньо",
        difficultyHard:"Важко",
        useAi:"Використовувати AI для питань",
        autoNaming:"Використовувати AI для назви й опису тесту",
        textAnswerRatio:"Відсоток текстових питань (%)",
        creativityMode:"Різноманітність AI-питань",
        creativityHint:"Керує міксом типів AI-питань (пропуск у реченні, переклад, частина мови) та різноманітністю формулювань",
        creativityConservative:"Консервативно - переважно пропуск/переклад",
        creativityBalanced:"Збалансовано - рівний мікс усіх типів",
        creativityCreative:"Креативно - максимум різноманіття, більше питань про частину мови",
        triggerAuto:"Запустити зараз",
        triggering:"Виконується...",
        resultEventsTriggered:"подій оброблено",
        resultMessagesSent:"повідомлень надіслано",
      },
      activeTasks:{
        trayTitle:"Активні завдання",
        quizGenerationRunning:"Генерується тест для",
        quizGenerationSuccess:"Тест згенеровано для",
        quizGenerationError:"Не вдалося згенерувати тест для",
        viewInConstructor:"Відкрити в конструкторі",
        dismiss:"Закрити",
        toastSuccessTitle:"Успіх",
        toastErrorTitle:"Помилка",
      },
      studentsPage:{
        addStudent:"Додати студента",
        totalStudents:"Всього студентів",
        activeStudents:"Активних",
        testsLeaderTitle:"Найбільше пройдених розмов",
        accuracyLeaderTitle:"Найкраща точність відповідей",
        lessonsLeaderTitle:"Найбільше занять за останній місяць",
        lessonsCalendarLeaderTitle:"Найбільше занять цього місяця",
        hoursShort:"год",
        filterAllStatus:"Всі",
        copied:"Скопійовано",
      }
    },
    pl: {
      id:'Id',
      pages:{
        login:{
          loginTitle:"Zaloguj się",
          loginPlaceholder:"login...",
          passPlaceholder:"hasło...",
          loginButton:"Login"
        },
      },
      meta:"Imie ",
      type:"Typ",
      answers:"Odpowiedz",
        emailVerificationPromptText : 'Nie poprawny format emailu !'  ,
        clients : "Klienci",
        client : "Klient",
        dashboard : "Dashboard",
        users : "Użytkownicy",
        stage:"Etap",
        dLastContact:"Ostatni konakt",
        address:"Adres",
        age:"Wiek",
        probability:"Wiarygodnosc",
        language:"Język",
        category:"kategoria",
        product:"Produkt",
        price:"Cena",
        priceIndividual:"Cena indywidualna",
        priceGroup:"Cena grupowa",
        source:"Źródło",
        fill:"...",
        groupe:"Grupa",
        groups:"Grupy",
        resources:"Resources",
        teacher:"Teacher",
        gMeetId:"Gmeet ID",
        telegramUsername:"Telegram",
        set:"Sety",
        grid:"Grid",
        
        modals:{
          conversationprogress:{
            createTitle:"Tutaj możesz dodać quiz",
            updateDescription: "Tutaj możesz zaktualizować quiz",
            updateTitle : "Edycja quizu",
          },
          events:{
            createTitle:"Tutaj możesz dodać wydarzenie",
            updateDescription: "Tutaj możesz zaktualizować wydarzenie",
            updateTitle : "Edycja wydarzenia",
          },
          answers:{
            createTitle:"Tutaj możesz dodać wiadomość",
            updateDescription: "Tutaj możesz zaktualizować wiadomość",
            updateTitle : "Edycja wiadomości",
          },
          conversations:{
            createTitle:"Tutaj możesz dodać rozmowe",
            updateDescription: "Tutaj możesz zaktualizować rozmowe",
            updateTitle : "Edycja rozmowy",
          },
          students:{
            createTitle:"Tutaj możesz dodać studenta",
            updateDescription: "Tutaj możesz zaktualizować studenta",
            updateTitle : "Edycja studenta",
          },
          carDocuments:{
            createTitle:"Tutaj możesz dodać document",
            updateDescription: "Pola nie można edytować",
            updateTitle : "Edycja documentu nie mozliwa",
          },
          projects:{
            createTitle:"Tutaj możesz dodać projekt",
            updateDescription: "Tutaj możesz zaktualizować projekt",
            updateTitle : "Edycja projektu",
          },
         users:{
          createTitle:"Tutaj możesz dodać uzytkownika",
          updateDescription: "Tutaj możesz zaktualizować uzytkownika",
          updateTitle : "Edycja uzytkownika",
         },
         clients:{
          createTitle:"Tutaj możesz dodać klienta",
          updateDescription: "Tutaj możesz zaktualizować klienta",
          updateTitle : "Edycja klienta",
         },
         lessons:{
          createTitle:"Tutaj możesz dodać zajęcia",
          updateDescription: "Tutaj możesz zaktualizować zajęcia",
          updateTitle : "Karta zajęcia",
         },
         games:{
          createTitle:"Tutaj możesz dodać gre",
          updateDescription: "Tutaj możesz zaktualizować gre",
          updateTitle : "Edycja gry",
         },
         groups:{
          createTitle:"Tutaj możesz dodać grupę",
          updateDescription: "Tutaj możesz zaktualizować grupę",
          updateTitle : "Edycja grupy",
         },
         quizGeneration:{
          title:"Generuj test",
          lessonLabel:"Lekcja",
          lessonDefault:"Bez lekcji (opcjonalnie)",
          additionalWordsLabel:"Dodatkowe słowa",
          additionalWordsPlaceholder:"Szukaj słowa...",
          studentWordsLabel:"Wybierz spośród słów ucznia",
          noStudentWords:"Ten uczeń nie ma jeszcze zapisanych słów",
          sourceHint:"Wybierz co najmniej jedno słowo, albo lekcję, do której są już dodane słowa",
          sourceRequiredError:"Najpierw wybierz co najmniej jedno słowo",
          difficultyLabel:"Trudność",
          difficultyDefault:"Domyślna",
          difficultyEasy:"Łatwy",
          difficultyMedium:"Średni",
          difficultyHard:"Trudny",
          questionCountLabel:"Liczba pytań",
          questionCountPlaceholder:"Domyślnie",
          optionsPerQuestionLabel:"Warianty odpowiedzi",
          optionsPerQuestionPlaceholder:"Domyślnie",
          textAnswerRatioLabel:"Odsetek pytań tekstowych (%)",
          textAnswerRatioPlaceholder:"Domyślnie",
          useAiLabel:"Styl pytań",
          useAiDefault:"Domyślny",
          useAiOn:"Wygenerowane przez AI",
          useAiOff:"Deterministyczny (bez AI)",
          creativityLabel:"Różnorodność pytań AI",
          creativityDefault:"Domyślnie",
          autoNamingLabel:"Użyj AI do nazwy i opisu testu",
          titleLabel:"Nazwa",
          titlePlaceholder:"Nazwa testu",
          descriptionLabel:"Opis",
          descriptionPlaceholder:"Opis testu",
          generateBtn:"Generuj",
          generating:"Generowanie...",
          genericError:"Nie udało się wygenerować testu",
          minimizeTooltip:"Uruchom w tle",
         }
        },
        value:"Znaczenie",
        pipeline : "Pipeline",
        "pipeline creator" : "Pipeline creator",
        stagetype: "Pipeline",
        projects : "Projekty",
        games : "Games",
        project : "Projekt",
        conversations:"Bot",
        mark:"Marka",
        registrNum:"Numer rejestracyjny",
        carRegistrNum:"Numer rejestracyjny",
        color:"Color",
        tasks : "Zadania",
        carDocuments : "Dokumenty",
        model : "Model",
        students : "Studenci",
        number:"Numer Documentu",
        dateFrom:"Data od",
        dateTo:"Data do",
        min:"min",
        cycledLesson:"Lekcja cykliczna",
        noParticipantsShort:"Brak uczniów",
        cycledLessonsFilter:"Cykliczne",
        dateRangeFilter:"Zakres dat",
        scheduleCreateCycledNote:"To dodaje nowy szablon lekcji cyklicznej - wybierz dzień tygodnia, na który się powtarza.",
        settings : "Ustawienia",
        logout : "Wyloguj",
        logging : "Logowania z urądzeń",
        backgroundHealth : "Stan procesów w tle",
        firstName : "Imie",
        lastName : "Nazwisko",
        surname : "Nazwisko",
        email : "Email",
        tel : "Tel",
        device : "Urządzenie",
        timeZone : "Strefa czasowa",
        timeZoneClear : "Wyczyść",
        lastActivity : "Ostatnia aktywność",
        placeholderSearch : "wyszukaj ...",
        save : "Zapisz",
        cancel : "Cofnij zmiany",
        unsavedChanges : "Niezapisane zmiany",
        dateBirth:"Data urodzenia",
        position:"Stanowisko",
        pl:"Polski",
        en:"Angielski",
        icons:"",
        feedbacks:{
          done:"Pomyślnie wykonano !",
          error:"Wystąpil problem !",
          wait:"Przetwazanie rządania...",
          timeout:"Za długi czas oczekiwania na odpowiedż od serwera !",
          forbidden:"Brak uprawnienia !",
        },
        name:"Nazwa",
        description:"Opis",
        responsibleId:"Odpowiedzialny",
        responsible:"Odpowiedzialny",
        facebook:"Facebook",
        hashCode:"Hash Code",
        conversationTypes:"Typ rozmowy",
        isPresent:"Opublikowane",
        level:"Poziom",
        typeId:"Typ",
        answers:"Pytania",
        estimationGroup:"Grupa oceny",
        answerTypeId:"Typ",
        conversation:"Rozmowa",
        isLast:"Ostatni",
        text:"Text",
        point:"Punkty",
        conversationId:"Rozmowa",
        isRight:"Poprawna",
        url:"Url",
        fromId:"Z odpowiedzi",
        nextId:"Do odpowiedzi",
        answerId:"Pytanie",
        estimationFunction:"Funkja oceny ",
        clasification:"Klasyfikacja",
        outerUserId:"User z Telegram",
        isFinished:"Czy zakończony",
        inProgress:"W trakcie",
        isBot:"Czy od bota",
        flagId:"Flag Id",
        dateTime:"Time stemp",
        messages:"Powiadomienia",
        openConstructor:"Otwórz w konstruktorze",
        answerConnector:"Pointy i czy poprawna",
        date:'Date',
        course:'Course',
        homework:'Homework',
        topicColumn:'Temat',
        exerciseHomeworkColumn:'Zadanie domowe',
        comment:'Comment',
        notes:'Notatki',
        saving:'Zapisywanie...',
        extra:'Extra',
        student:'Student',
        duration:'Czas trwania',
        start:'Początek',
        end:'Koniec',
        isPaid:'Opłacono',
        schedule:'Rozklad',
        ocupation:'Zajetość',
        location:'Lokacja',
        gdocument:'G_Document',
        isForMe:'Dla mnie',
        gDictionaryUa:'Słownik UA',
        gDictionaryEng:'Słownik Eng',
        algotithm:'Algorithm',
        find:'Szukaj',
        isCycled:"Czy cykliczny",
        hasBroadcast:"Jest powiadomienie",
        isActive:"Czy aktywny",
        active:"Aktywny",
        inactive:"Nieaktywny",
        Yes:"Tak",
        No:"Nie",
        "Empty list":"Pusta lista",
        "Loading ...":"Ładowanie ...",
        "not selected":"Nie wybrano",
        "clients conversations":"Rozmowy z botem",
        "empty list":"Brak rozmów",
        Public:'Ogólno dostępne',
        Personal:'Osobiste',
        Tests:'Rozmowy',
        noTests:'Brak rozmów na razie',
        Lessons:"Zajęcia",
        "Sum price":"Sum price",
        syncCalendar:"Synchronizuj kalendarz",
        syncCalendarRunning:"Synchronizacja...",
        syncCalendarDone:"Kalendarz zsynchronizowany",
        syncCalendarFailed:"Nie udało się zsynchronizować kalendarza",
        "Sum hours":"Sum hours",
        "Sum attendance":"Sum attendance",
        "Sum paid":"Opłacono",
        "Sum absence":"Nieobecności",
        Profile:'Profil',
        Planned:'Planowane',
        Words:'Słowa',
        Phrases:'Frazy',
        Courses:'Kursy',
        visible:'Widoczne',
        hidden:'Ukryte',
        addLinkCourse:'Dodaj link',
        addCopyCourse:'Skopiuj kurs',
        copyBadge:'Kopia',
        linkBadge:'Link',
        noCourses:'Brak dodanych kursów',
        pendingApprovalHint:'Czeka na Twoje zatwierdzenie',
        choosePlaceholderCourse:'Szukaj kursu...',
        Platform:'Platforma',
        grantPlatformAccess:'Nadaj dostęp do platformy',
        grantPlatformAccessConfirm:'Utwórz konto',
        platformEmailLabel:'Email',
        platformNameLabel:'Nazwa wyświetlana',
        platformCreateError:'Nie udało się utworzyć konta',
        platformAccountCreated:'Konto utworzone! Skopiuj link poniżej i wyślij go studentowi:',
        copyActivationLink:'Skopiuj link aktywacyjny',
        platformSendLinkHint:'Za pomocą tego linku student ustawi własne hasło i aktywuje konto.',
        close:'Zamknij',
        platformActive:'Platforma podłączona',
        platformActiveHint:'Student aktywował swoje konto na platformie',
        platformPending:'Oczekuje na aktywację',
        stageType:"Typ piplinu",
        dAdd:"Data dodania",
        weekDays:'Dni tygodnia',
        planedStudentEventType:"Typ zaplanowanego wydarzenia",
        "Easy test generation":"Proste generowanie testu",
        "Ai test generation":"Generowanie testu przez AI",
        Message:"Wiadomość",
        "Plan some event":"Zaplanuj wydarzenie",
        message:'Wiadomość',
        'Config planed event':"Konfiguracja wydarzenia",
        "Add day and time": "Dodaj dzień i godzinę",
        time:"Godzina",
        weekDay:"Dzień tygodnia",
        Monday:"Poniedziałek",
        Tuesday:"Wtorek",
        Wednesday:"Środa",
        Thursday:"Czwartek",
        Friday:"Piątek",
        Saturday:"Sobota",
        Sunday:"Niedziela",
        plannedEvents:{
          total:"Razem",
          recurring:"Cyklicznych",
          nextRun:"Następne uruchomienie",
          noNextRun:"Nie zaplanowano",
          oneTime:"Jednorazowo",
          type:"Typ",
          when:"Kiedy",
          noSchedule:"Brak harmonogramu",
          deleteConfirm:"Usunąć to zaplanowane wydarzenie?",
          hour:"Godzina",
          minute:"Minuta",
          testGenSectionTitle:"Ustawienia generowania testu",
          testGenHint:"Puste pole - używane jest ustawienie globalne z konfiguracji generacji testów",
          useGlobalDefault:"Domyślnie",
          wordSourceModeLabel:"Źródło słów",
        },
        groupsPage:{
          membersColumn:"Uczniowie",
          coursesColumn:"Kursy",
          nextLessonColumn:"Kolejna lekcja",
          noNextLesson:"Nie zaplanowano",
        },
        groupCard:{
          statsTotalLessons:"Wszystkich lekcji",
          membersTitle:"Uczniowie grupy",
          addStudentPlaceholder:"Wybierz ucznia",
          addStudentButton:"Dodaj",
          removeStudentConfirm:"Czy na pewno chcesz usunąć tego ucznia z grupy?",
          noMembers:"W grupie nie ma jeszcze uczniów",
          attendanceTitle:"Obecność na zajęciach",
          attendancePresent:"Obecny(-a)",
          attendanceAbsent:"Nieobecny(-a)",
          attendanceUnmarked:"Nie zaznaczono",
          testsTitle:"Rozmowy",
          noTests:"Nie przeprowadzono jeszcze żadnych rozmów",
          pendingStatus:"W trakcie",
          backToTests:"Powrót do rozmów",
          lessonsTitle:"Lekcje grupy",
          noLessons:"Brak lekcji",
          addLessonButton:"Dodaj lekcję",
          backToGroups:"Do grup",
          coursesTitle:"Kursy grupy"
        },
        tags:"Tagi",
        clientsPage:{
          totalClients:"Wszyscy klienci",
          newThisMonth:"Nowi w tym miesiącu",
          chartTitle:"Nowi klienci — ostatnie 6 miesięcy",
          funnelTitle:"Klienci wg etapu",
          allStageTypes:"Wszystkie",
          addClient:"Dodaj klienta",
          createClientTitle:"Nowy klient",
          tagsPlaceholder:"Nowy tag...",
          noTags:"Brak tagów",
          months:["Sty","Lut","Mar","Kwi","Maj","Cze","Lip","Sie","Wrz","Paź","Lis","Gru"],
        },
        weekDaysShort:["Pon","Wt","Śr","Czw","Pt","Sob","Nie"],
        weekDaysFull:["Poniedziałek","Wtorek","Środa","Czwartek","Piątek","Sobota","Niedziela"],
        lessonParticipants:"Uczestnicy zajęć",
        lessonWords:"Słowa zajęcia",
        lessonWordsEmpty:"Brak słów",
        lessonWordsPlaceholder:"Szukaj słowa...",
        lessonWordsAddBtn:"Dodaj słowo",
        lessonWordsAddNewBtn:"Brak w słowniku - utwórz przez AI",
        lessonPhrases:"Frazy zajęcia",
        lessonPhrasesEmpty:"Brak fraz",
        lessonPhrasesAddBtn:"Dodaj frazę",
        lessonTopics:"Powiązane tematy",
        lessonTopicsEmpty:"Brak powiązanych tematów",
        lessonTopicsAddPlaceholder:"Szukaj tematu...",
        lessonTopicsSingleParticipantOnly:"To zajęcie nie ma jeszcze uczestników",
        lessonTopicsNoCourses:"Student nie ma przypisanych kursów",
        lessonTopicsNoGroupCourses:"Grupa nie ma przypisanych kursów",
        lessonTopicsNoCommonCourse:"Ci studenci nie mają wspólnego kursu",
        lessonTopicsPickStudent:"Czyj workspace otworzyć?",
        lessonTopicsNoStudentHasCourse:"Żaden student tego zajęcia nie ma tego kursu",
        workspaceTopicLessons:"Zajęcia",
        workspaceTopicLessonsEmpty:"Brak powiązanych zajęć",
        workspaceTopicLessonsAddPlaceholder:"Szukaj zajęć...",
        workspaceTopicLessonsNone:"Student nie ma jeszcze zajęć",
        lessonShowMore:"Więcej ustawień",
        lessonHideMore:"Zwiń ustawienia",
        lessonHomeworks:"Zadania domowe",
        lessonHomeworksEmpty:"Brak zadań domowych",
        lessonHomeworkAdd:"Dodaj zadanie domowe",
        lessonHomeworkNeedsTopic:"Najpierw przypisz temat do zajęcia",
        lessonHomeworkTextPlaceholder:"Opis zadania...",
        lessonHomeworkCreateExercise:"Stwórz nowe ćwiczenie",
        lessonHomeworkSearchExercise:"Szukaj ćwiczenia...",
        lessonHomeworkExerciseDefaultName:"Ćwiczenie",
        lessonHomeworkMarkComplete:"Oznacz jako zrobione",
        lessonHomeworkMarkIncomplete:"Oznacz jako niezrobione",
        blockMarkerAdd:"Dodaj marker do bloku",
        blockMarkerRemove:"Usuń marker",
        blockMarkerHomePractice:"Do przećwiczenia w domu",
        blockMarkerSkip:"Pomijamy ten blok",
        blockMarkerImportant:"Bardzo ważne",
        canvasOpen:"Otwórz canvas tematu",
        canvasBackToTopic:"Wróć do tematu",
        canvasResetView:"reset",
        canvasToolSelect:"Zaznacz / przesuń",
        canvasToolPencil:"Ołówek",
        canvasToolRect:"Prostokąt",
        canvasToolEllipse:"Elipsa",
        canvasToolArrow:"Strzałka",
        canvasToolText:"Tekst",
        canvasToolImage:"Obrazek",
        canvasToolVideoEmbed:"Osadź wideo",
        canvasStudentCursor:"Student",
        canvasTeacherCursor:"Nauczyciel",
        canvasDeleteElement:"Usuń",
        canvasPresenceNoOne:"Jeszcze nikogo tu nie ma",
        canvasPresenceCount:"{count} tutaj",
        videoEmbedUrlLabel:"Link do wideo",
        videoEmbedUrlPlaceholder:"https://www.youtube.com/watch?v=...",
        videoEmbedDescriptionLabel:"Opis",
        videoEmbedDescriptionPlaceholder:"Opcjonalnie",
        videoEmbedEmptyHint:"Brak linku do wideo",
        videoEmbedUnrecognized:"Nie udało się rozpoznać tego linku do osadzenia",
        videoEmbedSave:"Zapisz",
        videoEmbedCancel:"Anuluj",
        today:"Dzisiaj",
        nextLesson:"Następna lekcja za",
        lastLesson:"Ostatnia lekcja",
        daysShort:"dni",
        hoursShort:"godz",
        minutesShort:"min",
        monthsShort:"mies",
        lessonStartsIn:"Rozpocznie się za",
        lessonEndedLabel:"Zakończyła się",
        agoSuffix:"temu",
        lessonInProgress:"Trwa teraz",
        "Daily schedule by":"Plan dnia na",
        noLessonsToday:"Brak zajęć dzisiaj",
        dailyScheduleStatPast:"minęło",
        dailyScheduleStatCurrent:"trwa",
        dailyScheduleStatUpcoming:"nadchodzi",
        latestBotConversations:"Ostatnio utworzone rozmowy bota",
        recentHomeworkTitle:"Ostatnio wykonane zadania domowe",
        recentHomeworkEmpty:"Brak wykonanych zadań domowych",
        recentHomeworkLesson:"Lekcja",
        recentHomeworkTasks:"zad.",
        recentHomeworkScore:"Wynik",
        recentHomeworkOpen:"Otwórz kurs studenta",
        recentHomeworkNoCourse:"Otwórz podgląd zadania domowego",
        recentHomeworkJustNow:"przed chwilą",
        lessonsNoHomeworkTitle:"Ostatnie zajęcia bez zadania domowego (3 dni)",
        lessonsNoHomeworkEmpty:"W ostatnich 3 dniach każde ostatnie zajęcie ma zadanie domowe",
        lessonsNoHomeworkChip:"bez zadania",
        lessonsNoHomeworkOpen:"Otwórz zajęcia",
        hourlyTelegramUsage:"Godzinowe wykorzystanie czatu z botem Telegram",
        pendingApprovalsTitle:"Oczekujące zatwierdzenia od wszystkich studentów",
        pendingApprovalsEmpty:"Nic nie czeka na Twoje zatwierdzenie",
        questionsShort:"pyt.",
        wordsTab:{
          addExisting:"Dodaj słowo studentowi",
          addNew:"Dodaj nowe słowo",
          searchPlaceholder:"Szukaj słów studenta...",
          searchHint:"Wpisz co najmniej jedną literę, aby wyszukać",
          aiAssist:"Uzupełnij za pomocą AI",
          aiAssistGenerating:"Generuję... (do minuty)",
          aiAssistError:"Nie udało się wygenerować parametrów słowa",
          spellingSuggestionLabel:"Czy chodziło Ci o:",
          primaryWords:"Słowa",
          secondaryWords:"Napotkane jako warianty",
          noWords:"Brak słów",
          sortNewest:"Najnowsze",
          sortProficiency:"Biegłość",
          word:"Słowo",
          partOfSpeech:"Część mowy",
          frequency:"Częstotliwość",
          ukTranslation:"Tłumaczenie",
          translationsPlaceholder:"Dodaj znaczenie...",
          noTranslations:"Brak tłumaczeń",
          transcriptionBr:"Transkrypcja brytyjska",
          transcriptionUs:"Transkrypcja amerykańska",
          tense:"Czas",
          form:"Forma",
          proficiency:"Biegłość",
          allPartsOfSpeech:"Wszystkie części mowy",
          allTenses:"Wszystkie czasy",
          allForms:"Wszystkie formy",
        },
        irregularVerbsBoard:{
          tabLabel:"Czasowniki nieregularne",
          searchPlaceholder:"Szukaj czasownika...",
          noGroups:"Brak jeszcze grup czasowników nieregularnych",
          loadError:"Nie udało się wczytać czasowników nieregularnych - endpoint serwera jest niedostępny",
          roleBase:"Forma podstawowa",
          rolePast:"Czas przeszły",
          roleParticiple:"Imiesłów",
          missingLabel:"Jeszcze nie nauczone",
        },
        screenshotImport:{
          title:"Import ze zrzutu ekranu",
          pasteHint:"Wklej obraz (Ctrl+V) albo wybierz plik",
          chooseFile:"Wybierz plik",
          recognize:"Rozpoznaj tekst",
          recognizing:"Rozpoznawanie...",
          textLabel:"Rozpoznany tekst (możesz go poprawić)",
          blanksCount:"Znaleziono luk",
          lowConfidence:"Część słów rozpoznano z niską pewnością - sprawdź tekst",
          ocrUnavailable:"Rozpoznawanie tekstu jest niedostępne na serwerze",
          ocrFailed:"Nie udało się rozpoznać tekstu",
          generate:"Wygeneruj zadanie",
          generating:"Generowanie...",
          draftTitle:"Szkic zadania",
          nameLabel:"Nazwa zadania",
          questionsCount:"Pytań",
          createExercise:"Utwórz zadanie",
          creating:"Tworzenie...",
          draftFailed:"AI nie zwróciło użytecznego zadania - spróbuj ponownie",
          createFailed:"Nie udało się utworzyć zadania",
          typeFillBlank:"Uzupełnij luki",
          typeMultipleChoice:"Wybór odpowiedzi",
          typeTrueFalse:"Prawda / fałsz",
          typeOrdering:"Kolejność",
          typeMatching:"Pary",
          regenerate:"Wygeneruj ponownie",
          removeQuestion:"Usuń",
          cancel:"Anuluj",
          instructionLabel:"O czym ma być zadanie? (opcjonalnie)",
          instructionPlaceholder:"np. tylko słowa rymujące się, prostsze pytania",
          sectionImage:"2. Zdjęcie z tekstem",
          sectionText:"3. Tekst (możesz go poprawić albo napisać samemu)",
          sectionDraft:"4. Szkic od AI",
          optional:"opcjonalnie",
          textPlaceholder:"Wklej lub napisz tekst zadania tutaj…",
          editHint:"Zmień tekst pytań albo usuń zbędne.",
          typeHeading:"Nagłówek",
          typeText:"Tekst",
          typeList:"Lista",
          typeImage:"Obraz",
importButton:"Import ze zdjęcia",
          importTitle:"Import bloków ze zdjęcia",
          addToExercise:"Dodaj do zadania",
          addedCount:"Dodano bloków",
          imageTool:{
            button:"Obraz ze schowka",
            title:"Obraz ze schowka",
            zone:"Naciśnij Ctrl+V, żeby wkleić tu zrzut",
            readClipboard:"Odczytaj schowek",
            recognizing:"Rozpoznawanie...",
            copy:"Kopiuj tekst",
            addAsText:"Dodaj jako blok tekstu",
            added:"Dodano blok tekstu",
            noImage:"W schowku nie ma obrazu",
            failed:"Nie udało się rozpoznać tekstu",
            close:"Zamknij",
          },
        },
        phrasesTab:{
          textPlaceholder:"Napisz frazę...",
          translationPlaceholder:"Tłumaczenie (opcjonalnie)",
          addBtn:"Dodaj frazę",
          existingLabel:"Użyj istniejącej frazy:",
          noPhrasesYet:"Brak fraz",
          phraseTypePhrase:"Frazy",
          phraseTypeSentence:"Zdania",
        },
        platformTab:{
          pendingRequestsTitle:"Oczekujące na zatwierdzenie",
          noPendingRequests:"Nic nie czeka na Twoje zatwierdzenie",
          approve:"Pokaż",
          reject:"Odrzuć",
          actionsTitle:"Działania konta platformy",
          accountActiveLabel:"Konto aktywne",
          accountStatusOn:"Konto jest aktywne",
          accountStatusOff:"Konto jest nieaktywne",
          accountActiveError:"Nie udało się zmienić statusu konta",
          resetPasswordButton:"Link do resetu hasła",
          resetPasswordError:"Nie udało się wygenerować linku",
          resetPasswordHint:"Skopiuj link i przekaż go studentowi samodzielnie.",
        },
        sessionsPanel:{
          removeConfirm:"Usunąć tę sesję?",
        },
        themeSettings:{
          title:"Kolory",
          editingLight:"Edycja: tryb jasny",
          editingDark:"Edycja: tryb ciemny",
          groupBackgrounds:"Tła",
          groupText:"Tekst",
          groupBorders:"Obramowania i linie",
          groupAccents:"Akcenty i poświata",
          bgColor:"Tło",
          bgPrimaryColor:"Tło główne",
          bgSecondaryFillColor:"Wypełnienie drugorzędne",
          bgButtonsColor:"Przyciski",
          bgModalColor:"Podkład modala",
          bgModalColor2:"Tło modala",
          bgGreef:"Panel akcentowy",
          bgTableColor:"Tło tabeli",
          bgInputsColor:"Pola formularzy",
          bgInfopanels:"Panele informacyjne",
          bgElementColor:"Wyróżniony element",
          mainTextColor:"Tekst główny",
          secondaryTextColor:"Tekst drugorzędny",
          lighttextColor:"Tekst akcentowy",
          borderColor:"Obramowanie",
          borderLeftColor:"Akcent lewej krawędzi",
          linesColor:"Linie",
          secondayrBtns:"Przyciski drugorzędne",
          shadowColorOne:"Poświata (subtelna)",
          shadowColorTwo:"Poświata (mocna)",
          gradientLinear:"Liniowy",
          gradientRadial:"Radialny",
          gradientCircle:"Koło",
          gradientEllipse:"Elipsa",
          gradientBarHint:"Kliknij pasek aby dodać kolor, przeciągnij kropkę aby zmienić pozycję",
          toolbarTitle:"Narzędzia",
          sessionsTitle:"Urządzenia",
        },
        backgroundHealthPage:{
          title:"Stan procesów w tle",
          filterType:"Typ",
          filterLevel:"Poziom",
          filterFrom:"Od",
          filterTo:"Do",
          allTypes:"Wszystkie typy",
          allLevels:"Wszystkie poziomy",
          typeWordClassification:"Klasyfikacja słów",
          typeWordDiscovery:"Wyszukiwanie nowych słów",
          typeLessonReminder:"Przypomnienia o zajęciach",
          typeCalendarSync:"Synchronizacja kalendarza",
          typePlannedEvents:"Zaplanowane wydarzenia",
          typeCycledLessonPropagation:"Przenoszenie lekcji",
          typeTelegramSend:"Wysyłki Telegram",
          levelInfo:"Info",
          levelWarning:"Ostrzeżenie",
          levelError:"Błąd",
          viewRecent:"Najnowsze",
          viewAggregated:"Zgrupowane",
          noEntries:"Brak wpisów",
          loading:"Ładowanie...",
          loadError:"Nie udało się załadować",
          occurrences:"wystąpień",
          lastSeen:"Ostatnio widziano",
          details:"Szczegóły",
          settingsLinkTitle:"Stan procesów w tle",
          settingsLinkDescription:"Przegląd logów cronów, błędów i statusu wysyłek Telegram",
        },
        vocabularyConfigPage:{
          settingsLinkTitle:"Konfiguracja słownictwa",
          settingsLinkDescription:"Konfiguracja AI do wyszukiwania słów, przeglądarka słownika, statystyki Gemini",
          title:"Konfiguracja słownictwa",
          configSectionTitle:"Konfiguracja cronów",
          classifyEnabled:"Klasyfikacja włączona",
          classifyBatchSize:"Rozmiar paczki",
          classifyMaxBatchesPerRun:"Maks. paczek na raz",
          classifyBatchHint:"Ile słów jest pobieranych i przetwarzanych podczas jednego uruchomienia crona - wewnątrz automatycznie dzielone na mniejsze zapytania do AI (nie da się tego tu skonfigurować).",
          classifyIntervalMinutes:"Uruchamiaj co (min)",
          classifyConditionsTitle:"Słowo oczekuje, jeśli...",
          classifyCheckUnverified:"Jeszcze niezweryfikowane",
          classifyCheckMissingPartOfSpeech:"Brak części mowy",
          classifyCheckMissingFrequency:"Brak częstotliwości",
          classifyCheckMissingTense:"Brak czasu",
          classifyCheckMissingForm:"Brak formy",
          classifyCheckMissingTranslation:"Brak tłumaczenia",
          discoveryEnabled:"Wyszukiwanie nowych słów włączone",
          discoveryWordsPerRun:"Słów na raz",
          discoveryIntervalHours:"Uruchamiaj co (godz)",
          discoverySourceMode:"Źródło słów",
          sourceModeAiGenerated:"Generowane przez AI (wg części mowy + częstotliwości)",
          sourceModeIrregularVerbs:"Czasowniki nieregularne (lista referencyjna)",
          sourceModeTextSource:"Z prawdziwego tekstu (Wikipedia)",
          irregularVerbsStatus:"{covered} z {total} form czasowników nieregularnych już w słowniku",
          irregularVerbsNoReference:"Lista referencyjna jeszcze nie wypełniona - zostanie pobrana od AI przy pierwszym uruchomieniu",
          refreshIrregularVerbs:"Odśwież listę referencyjną",
          textSourceTodayTopic:"Dzisiejszy temat",
          pasteTextTitle:"Lub wklej własny tekst",
          pasteTextPlaceholder:"Wklej artykuł lub dowolny angielski tekst - zostaną z niego wyciągnięte nowe słowa",
          pasteTextButton:"Wyciągnij słowa z tego tekstu",
          discoveryPosMode:"Docelowa część mowy",
          posModeAuto:"Automatyczna rotacja codziennie",
          posModeFixed:"Ustalona",
          discoveryFixedPartOfSpeech:"Ustalona część mowy",
          discoveryMinFrequency:"Min. częstotliwość (Zipf)",
          discoveryMaxFrequency:"Maks. częstotliwość (Zipf)",
          triggerClassify:"Uruchom klasyfikację teraz",
          triggerDiscover:"Uruchom wyszukiwanie teraz",
          triggering:"Trwa...",
          resultPending:"oczekujących",
          resultApplied:"zastosowano",
          resultBatches:"paczek",
          resultRequested:"zapytano",
          resultInserted:"dodano",
          progressTitle:"Postęp na żywo",
          progressBatch:"Paczka",
          progressFailed:"błąd",
          browserSectionTitle:"Słownik",
          totalWordsLabel:"Wszystkich słów",
          searchPlaceholder:"Szukaj słów...",
          allVerified:"Wszystkie",
          verifiedYes:"Zweryfikowane",
          verifiedNo:"Niezweryfikowane",
          addWord:"Dodaj słowo",
          studentCountHeader:"Uczniowie",
          chartSectionTitle:"Wykorzystanie AI",
          effectivenessSectionTitle:"Efektywność",
          range24h:"24h",
          range7d:"7d",
          range30d:"30d",
          statTotal:"Łącznie zapytań",
          statSuccessRate:"Skuteczność",
          statErrors:"Błędy",
          statAvgDuration:"Śr. czas odpowiedzi",
          chartRequests:"Zapytania w czasie",
          chartDuration:"Czas odpowiedzi w czasie",
          legendSuccess:"Sukces",
          legendError:"Błąd",
          showTable:"Pokaż tabelę",
          hideTable:"Ukryj tabelę",
          noUsageData:"Brak jeszcze danych o wykorzystaniu API",
        },
        aiConfigPage:{
          settingsLinkTitle:"Dostawca AI",
          settingsLinkDescription:"Wybierz aktywnego dostawcę AI oraz model używany przez każdego z nich",
          title:"Konfiguracja dostawcy AI",
          activeProvider:"Aktywny dostawca",
          providerGemini:"Gemini (Google)",
          providerOpenai:"OpenAI",
          geminiModel:"Model Gemini",
          openaiModel:"Model OpenAI",
          groqModel:"Model Groq",
          providerGroq:"Groq",
          activeBadge:"aktywny",
          autoSwitchEnabled:"Automatyczne przełączanie przy limicie",
          autoSwitchHintOn:"Najpierw próbuje Gemini, potem Groq (oba darmowe), i dopiero gdy oba mają aktualnie wyczerpany limit — przełącza na OpenAI (płatny); wraca automatycznie, gdy tylko któryś z breakerów się samoistnie odblokuje (24h). Wybrany powyżej dostawca jest wtedy ignorowany.",
          autoSwitchHintOff:"Wyłączone — zawsze używany jest dostawca wybrany powyżej, nic nie przełącza się automatycznie.",
          effectiveProviderLabel:"Aktualnie aktywny:",
          rateLimited:"Limit zapytań — wyłączone",
          rateLimitedSince:"od",
          clearRateLimit:"Wyczyść limit",
          clearingRateLimit:"Czyszczę...",
        },
        apiUsageChart:{
          range24h:"24h",
          range7d:"7d",
          range30d:"30d",
          statTotal:"Łącznie zapytań",
          statSuccessRate:"Skuteczność",
          statErrors:"Błędy",
          statAvgDuration:"Śr. czas odpowiedzi",
          chartRequests:"Zapytania w czasie",
          chartDuration:"Czas odpowiedzi w czasie",
          legendSuccess:"Sukces",
          legendError:"Błąd",
          showTable:"Pokaż tabelę",
          hideTable:"Ukryj tabelę",
          showRequests:"Pokaż ostatnie zapytania",
          hideRequests:"Ukryj ostatnie zapytania",
          colTime:"Czas",
          colContext:"Kontekst",
          colStatus:"Status",
          colHttpCode:"Kod HTTP",
          colDuration:"Czas trwania",
          requestBodyLabel:"Zapytanie",
          responseBodyLabel:"Odpowiedź",
          noUsageData:"Brak jeszcze danych o wykorzystaniu API",
        },
        wordCronEffectivenessChart:{
          classifyTitle:"Aktualizacja słów (klasyfikacja)",
          discoveryTitle:"Dodawanie nowych słów",
          legendSuccessClassify:"Zaktualizowano",
          legendFailClassify:"Nie zaktualizowano",
          legendSuccessDiscovery:"Dodano",
          legendFailDiscovery:"Nie dodano",
          statTotal:"Łącznie przetworzonych słów",
          statSuccessRate:"Skuteczność",
          colDate:"Data",
          colSuccess:"Sukces",
          colFail:"Niepowodzenie",
          colRate:"Skuteczność",
          noData:"Brak jeszcze danych",
        },
        quizGenerationConfigPage:{
          settingsLinkTitle:"Generowanie testów",
          settingsLinkDescription:"Konfiguracja domyślnych ustawień automatycznej generacji testów oraz ręczne uruchomienie",
          title:"Konfiguracja generowania testów",
          enabled:"Automatyczna generacja włączona",
          wordSourceMode:"Domyślne źródło słów",
          sourceModeLastLesson:"Ostatnia lekcja",
          sourceModeDateRange:"Zakres dat",
          dateRangeDays:"Zakres dat (dni)",
          questionCount:"Liczba pytań",
          optionsPerQuestion:"Warianty odpowiedzi na pytanie",
          difficulty:"Trudność",
          difficultyEasy:"Łatwy",
          difficultyMedium:"Średni",
          difficultyHard:"Trudny",
          useAi:"Użyj AI do tworzenia pytań",
          autoNaming:"Użyj AI do nazwy i opisu testu",
          textAnswerRatio:"Odsetek pytań tekstowych (%)",
          creativityMode:"Różnorodność pytań AI",
          creativityHint:"Steruje mieszanką typów pytań AI (luka w zdaniu, tłumaczenie, część mowy) oraz różnorodnością sformułowań",
          creativityConservative:"Zachowawczo - głównie luka w zdaniu/tłumaczenie",
          creativityBalanced:"Zbalansowane - równy miks wszystkich typów",
          creativityCreative:"Kreatywnie - maksimum różnorodności, więcej pytań o część mowy",
          triggerAuto:"Uruchom teraz",
          triggering:"Trwa...",
          resultEventsTriggered:"zdarzeń obsłużono",
          resultMessagesSent:"wiadomości wysłano",
        },
        activeTasks:{
          trayTitle:"Aktywne zadania",
          quizGenerationRunning:"Generowanie testu dla",
          quizGenerationSuccess:"Test wygenerowany dla",
          quizGenerationError:"Nie udało się wygenerować testu dla",
          viewInConstructor:"Otwórz w konstruktorze",
          dismiss:"Zamknij",
          toastSuccessTitle:"Sukces",
          toastErrorTitle:"Błąd",
        },
        studentsPage:{
          addStudent:"Dodaj studenta",
          totalStudents:"Wszyscy studenci",
          activeStudents:"Aktywnych",
          testsLeaderTitle:"Najwięcej ukończonych rozmów",
          accuracyLeaderTitle:"Najlepsza trafność odpowiedzi",
          lessonsLeaderTitle:"Najwięcej zajęć w ostatnim miesiącu",
          lessonsCalendarLeaderTitle:"Najwięcej zajęć w tym miesiącu kalendarzowym",
          hoursShort:"godz.",
          filterAllStatus:"Wszyscy",
          copied:"Skopiowano",
        }
    }
}
export default language;